<template>
  <SidebarComponent />
  <div class="dashboard-layout">
    <div class="content-container">
      <div class="card-container">
        <div class="titolo-card">
          <h1>{{ pageTitle }}</h1>

<!-- Bottone per mostrare/nascondere i filtri -->
<button @click="toggleFilters" class="filter-toggle-button">
  {{ showFilters ? "Nascondi Filtri" : "Mostra Filtri" }}
</button>

<FilterModule
  class="filter-module-fixed"
  v-show="showFilters"
  ref="filterModule"
  :userData="savedUserData"
  :initialFilters="filterInitialFilters"
  @filtered-data="handleFilteredData"
  @filters-changed="handleFiltersChanged"
/>


        </div>

        </div>

        
        <div v-if="currentUserRole === 'Studio'" class="read-only-message">
  Sei in modalità lettura. Puoi aggiornare solo la colonna "Consegna programmi"; per qualsiasi errore o urgenza contatta
  <a href="mailto:direzione@fusco.fit" class="email-link">direzione@fusco.fit</a> per modificare i dati.
</div>



        <div class="loader" v-if="isLoading">
          <h4>Caricamento in corso...</h4>
        </div>

        <div v-else class="dataset-summary">
          <span>Mostrando {{ visibleUserCount }} utenti</span>
          <span v-if="showOnlyMissingLastConsegna" class="dataset-summary__status">
            su {{ filteredUserData.length }} filtrati
          </span>
          <span v-if="isBackgroundLoading" class="dataset-summary__status">(caricamento completo in corso…)</span>
          <span v-else-if="isFullDataReady && totalUserCount">su {{ totalUserCount }} totali</span>
          <button
            type="button"
            class="sync-button dataset-summary__missing-filter"
            :class="{
              syncing: missingLastConsegnaLoading,
              'is-active': showOnlyMissingLastConsegna
            }"
            @click="toggleMissingLastConsegnaFilter"
            :disabled="!showOnlyMissingLastConsegna && !filteredUserData.length"
          >
            <span class="material-icons sync-button__icon" aria-hidden="true">
              {{ missingLastConsegnaLoading ? 'autorenew' : showOnlyMissingLastConsegna ? 'filter_alt_off' : 'filter_alt' }}
            </span>
            <span class="sync-button__label">
              {{ showOnlyMissingLastConsegna ? 'Mostra tutti' : 'Solo ultimi senza consegna' }}
            </span>
          </button>
          <button
            type="button"
            class="sync-button dataset-summary__sync-all"
            v-show="canSeeBulkSyncAll"
            @click="syncAllFilteredUsers"
            :disabled="!canSeeBulkSyncAll || bulkSyncRunning || !!syncingUserId || !visibleUserCount || missingLastConsegnaLoading"
            :class="{ syncing: bulkSyncRunning }"
          >
            <span class="material-icons sync-button__icon" aria-hidden="true">
              {{ bulkSyncRunning ? 'autorenew' : 'sync' }}
            </span>
            <span class="sync-button__label">
              {{ bulkSyncRunning ? `Sincronizza tutto ${bulkSyncDone}/${bulkSyncTotal}` : 'Sincronizza tutto' }}
            </span>
          </button>
          <span v-if="bulkSyncRunning" class="dataset-summary__status">
            Aggiornati {{ bulkSyncChangedUsers }} · errori {{ bulkSyncErrors }}
          </span>
          <span v-else-if="showOnlyMissingLastConsegna && missingLastConsegnaLoading" class="dataset-summary__status">
            (verifica programmi in corso…)
          </span>
          <span v-else-if="bulkSyncLastSummary" class="dataset-summary__status">
            {{ bulkSyncLastSummary }}
          </span>
        </div>



        <div v-if="renderedUserRows.length > 0" class="tickets" ref="ticketsContainer">
            <table ref="dataTable">
            <thead>
              <tr>
                <th class="col-azione">Azione</th>
                <th class="col-data">Data Creazione</th>
                <th class="col-data">Data Consegna</th>

                <th class="col-studio">Studio</th>
                <th class="col-email">Email</th>
                <th class="col-phone">Telefono</th>

                <th class="col-nome">Nome</th>
                <th class="col-cognome">Cognome</th>
                <th class="col-alimentazioni">Data Alimentazioni</th>
                <th class="col-allenamento">Allenamento</th>
                <th class="col-kcal">Kcal</th>
                <th class="col-strategia">Strategia</th>
                <th class="col-integrazione">Integrazione</th>
                <th class="col-sincr">Sincronizza</th>
                <th class="col-documenti">Documenti</th>
                <th class="col-consegna">Consegna programmi</th>

                <th class="col-freq">Freq Allenamento</th>
                <th class="col-statoutente">Stato Utente</th>

                <th class="col-notes">Note</th>
                <th class="col-note-alimentazione">Note Alimentazione</th>
                <th class="col-note-allenamento">Note Allenamento</th>
                <th class="col-note-interna">Nota Interna</th>

                <th class="col-note-nutrizionista">Nutrizionista</th>
                <th class="col-videocall">Videocall</th>
                
                <th class="col-nutrizionista-diet">Nutr. Dieta</th>

                <th class="col-note-select">Note</th>
                <th class="col-note-interna">Testo</th>

                <th class="col-color">Colore Riga</th>
                <th class="col-sincr col-sincr--secondary">Sincronizza</th>
              </tr>
            </thead>
            <tbody>
              <template
                v-for="(rowBlock, userIndex) in renderedUserRows"
                :key="rowBlock.user.id"
              >
    <tr
      v-for="(alimentazione, alimIndex) in rowBlock.programs"
      :key="alimentazione ? alimentazione.id : `no-alimentazione-${rowBlock.user.id}`"
      :class="[
        `bg-${rowBlock.user.rowColor}`,
        'program-row',
        {
          'user-group-start': alimIndex === 0,
          'program-row--latest': !!alimentazione && alimIndex === rowBlock.programs.length - 1
        }
      ]"
      :data-user-row="rowBlock.user.id"
      @click="handleUserChange(rowBlock.user.id)"
    >
      <td
        v-if="alimIndex === 0"
        class="col-azione"
        :rowspan="rowBlock.rowSpan"
      >
        <div class="buttons-container">
          <a
            v-if="rowBlock.user.uid"
            @click.stop
            :href="getUserDetailsLink(rowBlock.user.uid)"
            target="_blank"
            rel="noopener noreferrer"
            class="profile-button profile-button--link"
            title="Apri profilo utente"
            aria-label="Apri profilo utente"
          >
            <span class="material-icons" aria-hidden="true">visibility</span>
          </a>
          <span v-else class="profile-button profile-button--link profile-button--unavailable" title="Profilo non collegato: UID mancante" role="img" aria-label="Profilo non collegato: UID mancante">
            <span class="material-icons" aria-hidden="true">visibility</span>
          </span>
        </div>
      </td>

    <td v-if="alimIndex === 0" class="col-data" :rowspan="rowBlock.rowSpan">
      {{ formatDateTime(rowBlock.user.createdAt) }}
    </td>

    <td v-if="alimIndex === 0" class="col-data" :rowspan="rowBlock.rowSpan">
      <span
        class="date-display"
        @click.stop="openDatePicker(rowBlock.user.id, 'dataConsegna')"
        style="font-weight: bold; color: red; cursor: pointer;"
      >
        {{ formatDate(rowBlock.user.dataConsegna) }}
      </span>
      <input
        v-if="isDatePickerOpen(rowBlock.user.id, 'dataConsegna')"
        type="date"
        :value="formatDateForInput(rowBlock.user.dataConsegna)"
        :disabled="!canEdit"
        @change="updateDataConsegna(rowBlock.user.id, $event.target.value)"
        @blur="closeDatePicker(rowBlock.user.id, 'dataConsegna')"
        class="date-picker"
      />
    </td>

    <td v-if="alimIndex === 0" class="col-studio" :rowspan="rowBlock.rowSpan">{{ rowBlock.user.studio }}</td>
    <td v-if="alimIndex === 0" class="col-email" :rowspan="rowBlock.rowSpan">{{ rowBlock.user.email }}</td>

    <td v-if="alimIndex === 0" class="col-phone" :rowspan="rowBlock.rowSpan">
      <input
        type="text"
        v-model="rowBlock.user.phone"
        :disabled="!canEdit"
        @click.stop
        @blur="savePhone(rowBlock.user.id, rowBlock.user.phone)"
        class="text-input"
        placeholder="Inserisci telefono"
      />
    </td>

    <td v-if="alimIndex === 0" class="col-nome" :rowspan="rowBlock.rowSpan">{{ rowBlock.user.name }}</td>
    <td v-if="alimIndex === 0" class="col-cognome" :rowspan="rowBlock.rowSpan">{{ rowBlock.user.surname }}</td>

    <td class="col-alimentazioni">
      <div class="alimentazione-cell">
        <div v-if="alimentazione" class="alimentazione-row">
          <span
            class="date-display"
            @click.stop="openDatePicker(rowBlock.user.id, alimentazione.id)"
            style="cursor: pointer;"
          >
            {{ formatDate(alimentazione.dataCreazione) }}
          </span>
          <input
            v-if="isDatePickerOpen(rowBlock.user.id, alimentazione.id)"
            type="date"
            :value="formatDateForInput(alimentazione.dataCreazione)"
            :disabled="!canEdit"
            @change="updateDataCreazione(rowBlock.user.id, alimentazione.id, $event.target.value)"
            @blur="closeDatePicker(rowBlock.user.id, alimentazione.id)"
            class="date-picker"
          />
          <button
            @click.stop="deleteAlimentazione(rowBlock.user.id, alimentazione.id)"
            class="delete-button"
            :disabled="!canEdit"
          >
            <span class="material-icons">delete</span>
          </button>
        </div>

        <div v-else class="empty-cell">Nessun programma</div>
      </div>
    </td>

    <td class="col-allenamento">
      <template v-if="alimentazione">
        <input
          type="text"
          :value="editedFields[rowBlock.user.id]?.[alimentazione.id]?.allenamento ?? alimentazione.allenamento"
          :disabled="!canEdit"
          @click.stop
          @input="updateField(rowBlock.user.id, alimentazione.id, 'allenamento', $event.target.value)"
          class="text-input"
          placeholder="Allenamento"
          :tabindex="userIndex * 100 + alimIndex * 10"
        />
      </template>
      <span v-else class="empty-cell">-</span>
    </td>

    <td class="col-kcal">
      <template v-if="alimentazione">
        <input
          type="text"
          :value="editedFields[rowBlock.user.id]?.[alimentazione.id]?.kcalalimentazioni ?? alimentazione.kcalalimentazioni"
          :disabled="!canEdit"
          @click.stop
          @input="updateField(rowBlock.user.id, alimentazione.id, 'kcalalimentazioni', $event.target.value)"
          class="text-input"
          placeholder="Kcal"
          :tabindex="userIndex * 100 + alimIndex * 10"
        />
      </template>
      <span v-else class="empty-cell">-</span>
    </td>

    <td class="col-strategia">
      <template v-if="alimentazione">
        <input
          type="text"
          :value="editedFields[rowBlock.user.id]?.[alimentazione.id]?.strategia ?? alimentazione.strategia"
          :disabled="!canEdit"
          @click.stop
          @input="updateField(rowBlock.user.id, alimentazione.id, 'strategia', $event.target.value)"
          class="text-input"
          placeholder="Strategia"
          :tabindex="userIndex * 100 + alimIndex * 10"
        />
      </template>
      <span v-else class="empty-cell">-</span>
    </td>

    <td class="col-integrazione">
      <template v-if="alimentazione">
        <div class="integrazione-cell">
          <button
            type="button"
            class="integrazione-button"
            @click.stop="openIntegrazioneModal(rowBlock.user.id, alimentazione)"
            :disabled="!canEdit"
          >
            <span class="material-icons integrazione-button__icon">fact_check</span>
            <span>{{ getIntegrazioneButtonLabel(alimentazione) }}</span>
          </button>

          <div v-if="getIntegrazioneSummary(alimentazione)" class="integrazione-summary">
            {{ getIntegrazioneSummary(alimentazione) }}
          </div>
        </div>
      </template>
      <span v-else class="empty-cell">-</span>
    </td>

    <td class="col-sincr">
      <div v-if="alimIndex === rowBlock.programs.length - 1" class="sync-block">
        <button
          @click.stop="syncData(rowBlock.user.id)"
          class="sync-button"
          :disabled="!canEdit || bulkSyncRunning || !!syncingUserId"
          :class="{ syncing: syncingUserId === rowBlock.user.id }"
        >
          <span class="material-icons sync-button__icon" aria-hidden="true">
            {{ syncingUserId === rowBlock.user.id ? 'autorenew' : 'sync' }}
          </span>
          <span class="sync-button__label">
            {{ syncingUserId === rowBlock.user.id ? 'Sincronizzando…' : 'Sincronizza' }}
          </span>
        </button>
      </div>
    </td>

    <td class="col-documenti">
      <template v-if="alimentazione">
        <div class="file-actions">
          <div
            class="file-dropzone"
            :class="{
              'is-dragover': isDropZoneActive(rowBlock.user.id, alimentazione.id),
              'is-uploading': isUploading(rowBlock.user.id, alimentazione.id),
              'is-disabled': !canEdit || isUploading(rowBlock.user.id, alimentazione.id),
              'has-preview': !!getDropPreview(rowBlock.user.id, alimentazione.id)
            }"
            @dragenter.prevent="handleDropZoneEnter(rowBlock.user.id, alimentazione.id)"
            @dragover.prevent="handleDropZoneEnter(rowBlock.user.id, alimentazione.id)"
            @dragleave.prevent="handleDropZoneLeave(rowBlock.user.id, alimentazione.id)"
            @drop.prevent="handleFileDrop(rowBlock.user.uid, rowBlock.user.id, alimentazione.id, $event)"
            :aria-busy="isUploading(rowBlock.user.id, alimentazione.id)"
            aria-live="polite"
            role="button"
            tabindex="0"
            @click.stop="handleDropZoneClick(rowBlock.user.uid, rowBlock.user.id, alimentazione.id)"
            @keydown.enter.stop.prevent="handleDropZoneClick(rowBlock.user.uid, rowBlock.user.id, alimentazione.id)"
            @keydown.space.stop.prevent="handleDropZoneClick(rowBlock.user.uid, rowBlock.user.id, alimentazione.id)"
          >
            <template v-if="isUploading(rowBlock.user.id, alimentazione.id)">
              <span class="file-dropzone__spinner" aria-hidden="true"></span>
              <span>Caricamento in corso…</span>
            </template>
            <template v-else>
              <span class="material-icons file-dropzone__icon" aria-hidden="true">picture_as_pdf</span>
              <span class="file-dropzone__prompt">
                {{ getDropPreview(rowBlock.user.id, alimentazione.id) || 'Clicca o trascina qui il PDF' }}
              </span>
            </template>
          </div>
          <div v-if="alimentazione.fileUrl" class="file-info">
            <a class="file-link" :href="alimentazione.fileUrl" target="_blank" rel="noopener">
              Visualizza
            </a>
            <span v-if="alimentazione.dataFileCaricato" class="file-date">
              {{ formatDate(alimentazione.dataFileCaricato) }}
            </span>
          </div>
          <div
            v-if="getUploadMessage(rowBlock.user.id, alimentazione.id)"
            :class="[
              'file-status',
              `file-status--${getUploadMessage(rowBlock.user.id, alimentazione.id).type || 'info'}`
            ]"
            aria-live="polite"
          >
            {{ getUploadMessage(rowBlock.user.id, alimentazione.id).text }}
          </div>
        </div>
      </template>
      <span v-else class="empty-cell">-</span>
    </td>
    <td class="col-consegna">
      <template v-if="alimentazione">
        <div class="consegna-box">
            <div class="consegna-header">
              <div class="consegna-title">
                {{ getInvioProgramHeader(rowBlock.user, alimentazione) }}
              </div>
              <span class="consegna-step-tag">
                {{ getInvioStepLabel(alimentazione) }}
              </span>
            </div>
          <div class="consegna-steps">
            <label
              class="consegna-step-item consegna-step-item--custom"
              :class="{
                'is-done': isProgCustomEnabled(rowBlock.user, alimentazione),
                'is-disabled': isProgCustomDisabled(rowBlock.user, alimentazione)
              }"
            >
              <input
                type="checkbox"
                :checked="isProgCustomEnabled(rowBlock.user, alimentazione)"
                :disabled="isProgCustomDisabled(rowBlock.user, alimentazione)"
                @change="toggleProgCustomFlag(rowBlock.user, alimentazione, $event.target.checked, $event)"
              />
              <span>Prog. customizzato</span>
            </label>
            <label
              class="consegna-step-item consegna-step-item--delivery"
              :class="{
                'is-done': isConsegnaConfirmed(rowBlock.user, alimentazione),
                'is-disabled': isConsegnaDisabled(rowBlock.user, alimentazione)
              }"
            >
              <input
                type="checkbox"
                :checked="isConsegnaConfirmed(rowBlock.user, alimentazione)"
                :disabled="isConsegnaDisabled(rowBlock.user, alimentazione)"
                @change="toggleConsegnaFlag(rowBlock.user, alimentazione, $event.target.checked, $event)"
              />
              <span>{{ isConsegnaConfirmed(rowBlock.user, alimentazione) ? 'Consegnato' : 'Consegna' }}</span>
            </label>
          </div>
          <small
            v-if="!hasInvioStepRef(alimentazione)"
            class="consegna-hint consegna-hint--error"
          >
            Invio senza step collegato.
          </small>
          <small
            v-else-if="isConsegnaNotAvailable(alimentazione)"
            class="consegna-hint"
          >
            Nessuna consegna per questo check finale.
          </small>
        </div>
      </template>
      <span v-else class="empty-cell">-</span>
    </td>

    <td class="col-freq">
      <template v-if="alimentazione">
        <input
          type="text"
          :value="editedFields[rowBlock.user.id]?.[alimentazione.id]?.freqallenamento || alimentazione.freqallenamento"
          :disabled="!canEdit"
          @click.stop
          @input="updateField(rowBlock.user.id, alimentazione.id, 'freqallenamento', $event.target.value)"
          class="text-input"
          placeholder="Freq"
        />
      </template>
      <span v-else class="empty-cell">-</span>
    </td>

    <td v-if="alimIndex === 0" class="col-statoutente" :rowspan="rowBlock.rowSpan">{{ rowBlock.user.statoUtente }}</td>
    <td v-if="alimIndex === 0" class="col-notes" :rowspan="rowBlock.rowSpan">{{ rowBlock.user.notes }}</td>
    <td v-if="alimIndex === 0" class="col-note-alimentazione" :rowspan="rowBlock.rowSpan">{{ rowBlock.user.noteAlimentazione }}</td>
    <td v-if="alimIndex === 0" class="col-note-allenamento" :rowspan="rowBlock.rowSpan">{{ rowBlock.user.noteAllenamento }}</td>

    <td class="col-note-interna">
      <template v-if="alimentazione">
        <input
          type="text"
          :value="editedFields[rowBlock.user.id]?.[alimentazione.id]?.nota1 || alimentazione.nota1"
          :disabled="!canEdit"
          @click.stop
          @input="updateField(rowBlock.user.id, alimentazione.id, 'nota1', $event.target.value)"
          class="text-input"
          placeholder="Nota interna"
        />
      </template>
      <span v-else class="empty-cell">-</span>
    </td>

    <td class="col-note-nutrizionista">
      <template v-if="alimentazione">
        <select
          :value="editedFields[rowBlock.user.id]?.[alimentazione.id]?.nutrizionista || alimentazione.nutrizionista"
          :disabled="!canEdit"
          @click.stop
          @change="updateField(rowBlock.user.id, alimentazione.id, 'nutrizionista', $event.target.value)"
          class="text-input"
        >
          <option value="">Nutr. Videocall</option>
          <option value="francescadg">Francesca D.G.</option>
          <option value="celestina">Celestina</option>
          <option value="erika">Erika</option>
          <option value="martina">Martina</option>
          <option value="francesca">Francesca</option>
        </select>
      </template>
      <span v-else class="empty-cell">-</span>
    </td>

    <td class="col-videocall">
      <template v-if="alimentazione">
        <select
          :value="editedFields[rowBlock.user.id]?.[alimentazione.id]?.videocall || alimentazione.videocall"
          :disabled="!canEdit"
          @click.stop
          @change="updateField(rowBlock.user.id, alimentazione.id, 'videocall', $event.target.value)"
          class="text-input"
        >
          <option value="">Seleziona un'azione</option>
          <option value="chiamata">Chiamata</option>
          <option value="videocallfatta">Videocall Fatta</option>
          <option value="nonrisponde">Non risponde</option>
          <option value="ciricontatta">Ci ricontatta</option>
          <option value="inviatamail">Inviata mail</option>
          <option value="inviatoticket">Inviato Ticket</option>
          <option value="secondacall">Seconda call</option>
          <option value="rinnovo">Rinnovo</option>
        </select>
      </template>
      <span v-else class="empty-cell">-</span>
    </td>

    <td class="col-nutrizionista-diet">
      <template v-if="alimentazione">
        <select
          :value="editedFields[rowBlock.user.id]?.[alimentazione.id]?.nutrizionistadiet || alimentazione.nutrizionistadiet"
          :disabled="!canEdit"
          @click.stop
          @change="updateField(rowBlock.user.id, alimentazione.id, 'nutrizionistadiet', $event.target.value)"
          class="text-input"
        >
          <option value="">Nutr. Alimentazione</option>
          <option value="francescadg">Francesca D.G.</option>
          <option value="celestina">Celestina</option>
          <option value="erika">Erika</option>
          <option value="martina">Martina</option>
          <option value="francesca">Francesca</option>
        </select>
      </template>
      <span v-else class="empty-cell">-</span>
    </td>

    <td class="col-note-select">
      <template v-if="alimentazione">
        <select
          :value="editedFields[rowBlock.user.id]?.[alimentazione.id]?.noteselect || alimentazione.noteselect"
          :disabled="!canEdit"
          @click.stop
          @change="updateField(rowBlock.user.id, alimentazione.id, 'noteselect', $event.target.value)"
          class="text-input"
        >
          <option disabled value="">Seleziona nota</option>
          <option value="damodificare">Da modificare</option>
          <option value="corretta">Corretta</option>
        </select>
      </template>
      <span v-else class="empty-cell">-</span>
    </td>

    <td class="col-note-interna testo">
      <template v-if="alimentazione">
        <textarea
          class="text-input note-textarea"
          :value="editedFields[rowBlock.user.id]?.[alimentazione.id]?.noteinterna || alimentazione.noteinterna"
          :disabled="!canEdit"
          @click.stop
          @input="updateField(rowBlock.user.id, alimentazione.id, 'noteinterna', $event.target.value)"
          placeholder="Testo della nota"
        ></textarea>
      </template>
      <span v-else class="empty-cell">-</span>
    </td>

    <td v-if="alimIndex === 0" class="col-color" :rowspan="rowBlock.rowSpan">
      <select
        :value="getResolvedRowColor(rowBlock.user)"
        :disabled="!canEdit"
        @click.stop
        @change="handleRowColorChange(rowBlock.user, $event.target.value)"
        class="color-select"
      >
        <option value="">Colore</option>
        <option value="red">Rosso - no consegna</option>
        <option value="blue">Blu - video call da fare</option>
        <option value="yellow">Giallo - Uomo</option>
        <option value="protocollo">PROTOCOLLO 25</option>
        <option value="green">Verde - solo allenamento</option>
        <option value="pink">Rosa - solo dieta</option>
        <option value="">Nessun colore</option>
      </select>
    </td>
    <td v-if="alimIndex === 0" class="col-sincr col-sincr--secondary" :rowspan="rowBlock.rowSpan">
      <div class="sync-block">
        <button
          @click.stop="syncData(rowBlock.user.id)"
          class="sync-button"
          :disabled="!canEdit || bulkSyncRunning || !!syncingUserId"
          :class="{ syncing: syncingUserId === rowBlock.user.id }"
        >
          <span class="material-icons sync-button__icon" aria-hidden="true">
            {{ syncingUserId === rowBlock.user.id ? 'autorenew' : 'sync' }}
          </span>
          <span class="sync-button__label">
            {{ syncingUserId === rowBlock.user.id ? 'Sincronizzando…' : 'Sincronizza' }}
          </span>
        </button>
      </div>
    </td>
    </tr>
  </template>
</tbody>
          </table>
        </div>


        <div v-else>
          <p>Nessun dato disponibile.</p>
        </div>
      </div>
    </div>

  <IntegrazioneModal
    v-if="integrazioneModal"
    :user-id="integrazioneModal.userId"
    :alimentazione-id="integrazioneModal.alimentazioneId"
    :invii-doc-id="integrazioneModal.inviiDocId"
    :initial-entry="integrazioneModal.entry"
    :save-handler="saveIntegrationWithPendingChanges"
    :has-pending-changes="integrationHasPendingChanges"
    @close="integrazioneModal = null"
    @saved="onIntegrationSaved"
  />
</template>




<script>
import SidebarComponent from "../SidebarComponent.vue";
import FilterModule from "../module/FilterModule.vue";
import { defineAsyncComponent } from "vue";
import { getIntegrationLabel, getIntegrationSummary, INTEGRATION_FIELDS, preserveIntegrationFields } from "@/lib/integrazione";
import { saveIntegrationAssignment, updateProtectedProgramDocument } from "@/lib/integrazioneStore";
import { hasInviiPendingChanges, snapshotInviiPendingChanges } from "@/lib/inviiPendingChanges";
import { collection, getDocs, getFirestore, doc, updateDoc, getDoc, Timestamp, setDoc, query, where, deleteDoc, orderBy, onSnapshot, runTransaction, limit as limitFn } from "firebase/firestore";
import { getStorage, ref as storageRef, uploadBytes, getDownloadURL } from "firebase/storage";
import { getAuth } from 'firebase/auth';
import { setProgCustomFlag, setStepDone, stepKeyFromName } from "@/lib/percorsi";
import { buildLatestProgramMirror } from "@/lib/latestProgramMirror";

const IntegrazioneModal = defineAsyncComponent(() => import("../module/IntegrazioneModal.vue"));

function addBusinessDays(baseDate, businessDaysToAdd) {
  const result = new Date(baseDate);
  let addedDays = 0;

  while (addedDays < businessDaysToAdd) {
    result.setDate(result.getDate() + 1);
    const day = result.getDay();
    if (day !== 0 && day !== 6) {
      addedDays += 1;
    }
  }

  return result;
}




export default {
  props: {
    pageTitle: {
      type: String,
      default: "Elenco Invii Giornata"
    },
    fixedLastNoteFilter: {
      type: String,
      default: ""
    },
    maxProgramsShownOverride: {
      type: Number,
      default: null
    }
  },
  components: {
    SidebarComponent,
    FilterModule,
    IntegrazioneModal
  },


  data() {
    return {
      savedUserData: [], // Dati originali dal DB usati per i filtri
      userData: [], // Dati degli utenti
      isLoading: true, // Stato di caricamento
      editedFields: {}, // Oggetto temporaneo per mantenere i valori locali
      localFieldRefreshTimeouts: {}, // Solo aggiornamenti in memoria, nessuna scrittura al DB
      userSaveQueues: {}, // Serializza i salvataggi dello stesso utente
      activeDatePickers: {}, // Stato dei campi data aperti
      filteredUserData: [], // Dati filtrati in base al filtro
      showFilters: false, // Flag per mostrare/nascondere il box filtri
      currentUserId: "", // UID dell'utente autenticato
      currentUserRole: "", // Ruolo dell'utente corrente
      canEdit: false, // Flag per permessi di modifica
      isSyncing: false, // Flag per indicare se la sincronizzazione è in corso
      syncingUserId: null, // Tiene traccia dell'utente in sincronizzazione
      bulkSyncRunning: false, // Sync massiva in corso
      bulkSyncTotal: 0, // Totale utenti da sincronizzare
      bulkSyncDone: 0, // Utenti processati in sync massiva
      bulkSyncChangedUsers: 0, // Utenti con modifiche applicate in sync massiva
      bulkSyncErrors: 0, // Errori in sync massiva
      bulkSyncLastSummary: "", // Riepilogo ultima sync massiva
      uploadingStates: {}, // Stato dei caricamenti file per alimentazione
      activeDropZones: {}, // Stato attivo delle aree di trascinamento file
      uploadMessages: {}, // Messaggi di stato per caricamenti file
      uploadMessageTimeouts: {}, // Timer per la pulizia dei messaggi dropzone
      dropPreviews: {}, // Testo immediato mostrato nella dropzone
      rowColorPending: {}, // Colori non ancora sincronizzati
      rowColorSaveTimeouts: {}, // Timer per il salvataggio del colore
      lastFocusedUserId: null, // Ultimo utente interagito
      shouldPreserveFocus: false, // Mantieni la riga visibile dopo gli update
      dataConsegnaPending: {}, // Date consegna in attesa di salvataggio
      dataConsegnaSaveTimeouts: {}, // Timer per il salvataggio automatico dataConsegna
      autoSaveTimeouts: {}, // Timer per l'autosalvataggio dei campi select
      autoSaveInProgress: {}, // Stato di salvataggio automatico per utente
      autoSavePending: {}, // Richieste di autosalvataggio in coda
      isSaving: false, // Inizializza isSaving a false
      initialFetchLimit: 20, // Numero di record caricati rapidamente
      isFullDataReady: false, // Stato di disponibilità dei dati completi
      isBackgroundLoading: false, // Flag per caricamento in background
      totalUserCount: 0, // Conteggio totale degli utenti caricati
      filterRefreshTimeout: null, // Timer per riapplicare i filtri con debounce

      maxProgramsShown: 4, // Numero massimo di programmi da mostrare
      activeDocId: null, // Documento attivo nella tabella

      selectedFilters: {
        studio: "", // Studio selezionato
        startDate: "", // Data di inizio
        endDate: "", // Data di fine
        videocall: "", // Stato della videocall
        note: "", // Stato delle note
        color: "", // Colore della riga
        email: "", // Nuovo filtro per email
      },
      userProgramCache: {}, // Percorsi disponibili per utente
      userProgramLoading: {}, // Stato di caricamento percorsi per utente
      userProgramErrors: {}, // Errori di caricamento percorsi
      consegnaSavingState: {}, // Stato di salvataggio consegna per percorso
      progCustomSavingState: {}, // Stato di salvataggio prog custom per percorso
      programPrefetchLimit: 25, // Numero massimo di utenti per cui pre-caricare i percorsi
      enableRealtimeFlagChecks: false, // Controlli live su percorsi disattivati per performance
      showOnlyMissingLastConsegna: false, // Mostra solo utenti con consegna mancante sull'ultimo programma
      missingLastConsegnaLoading: false, // Stato caricamento lazy per il filtro consegna mancante
      missingLastConsegnaRequestId: 0, // Token per evitare race condition nel preload del filtro
      integrazioneModal: null,
    };
  },

  computed: {
    integrationHasPendingChanges() {
      const docId = this.integrazioneModal?.inviiDocId;
      return !!docId && hasInviiPendingChanges(this.editedFields[docId]);
    },

    filterInitialFilters() {
      return this.fixedLastNoteFilter
        ? { note: this.fixedLastNoteFilter }
        : {};
    },

    renderedUserRows() {
      if (!Array.isArray(this.filteredUserData)) return [];

      const rowBlocks = this.filteredUserData.map((user) => {
        const programs = this.buildProgramsForUser(user);
        const normalizedPrograms = programs.length ? programs : [null];

        return {
          user,
          programs: normalizedPrograms,
          rowSpan: normalizedPrograms.length || 1,
        };
      });

      if (!this.showOnlyMissingLastConsegna) {
        return rowBlocks;
      }

      return rowBlocks.filter((rowBlock) => this.shouldShowMissingLastConsegnaUser(rowBlock));
    },

    visibleUserCount() {
      return this.renderedUserRows.length;
    },

    visibleUserData() {
      return this.renderedUserRows.map((rowBlock) => rowBlock.user);
    },

    canSeeBulkSyncAll() {
      return this.canEdit && this.currentUserId === "HpMiFyBZnwX6EUf6VR9iCsHkqo82";
    },
  },

  mounted() {
  this.initAuth(); // Esegui l'inizializzazione dell'autenticazione
  this.listenToRealTimeUpdates(); // Avvia il listener in tempo reale

  // Imposta i valori di default per il filtro Data Consegna
  const today = new Date();
  const deliveryEnd = addBusinessDays(today, 3);

  this.selectedFilters.deliveryStartDate = today.toISOString().split("T")[0];
  this.selectedFilters.deliveryEndDate = deliveryEnd.toISOString().split("T")[0];

  // Applica subito i filtri appena i dati sono disponibili
  this.$nextTick(() => {
    if (this.$refs.filterModule) {
      this.$refs.filterModule.applyFilters();
    }
  });
},






  beforeUnmount() {
    if (this.activeDocId) {
      this.savePendingChanges(this.activeDocId); // Salva eventuali modifiche non sincronizzate
    }

  Object.values(this.localFieldRefreshTimeouts).forEach(clearTimeout);
  this.localFieldRefreshTimeouts = {};

  if (this.filterRefreshTimeout) {
    clearTimeout(this.filterRefreshTimeout);
    this.filterRefreshTimeout = null;
  }

  Object.values(this.uploadMessageTimeouts).forEach((timeoutId) => {
    clearTimeout(timeoutId);
  });
  this.uploadMessageTimeouts = {};

  this.shouldPreserveFocus = false;
  this.lastFocusedUserId = null;

  Object.values(this.rowColorSaveTimeouts).forEach((timeoutId) => {
    clearTimeout(timeoutId);
  });
  this.rowColorSaveTimeouts = {};

  Object.values(this.dataConsegnaSaveTimeouts).forEach((timeoutId) => {
    clearTimeout(timeoutId);
  });
  this.dataConsegnaSaveTimeouts = {};
  this.dataConsegnaPending = {};

  Object.values(this.autoSaveTimeouts).forEach((timeoutId) => {
    clearTimeout(timeoutId);
  });
  this.autoSaveTimeouts = {};
  this.autoSaveInProgress = {};
  this.autoSavePending = {};
}, 


  
methods: {
    toggleFilters() {
  this.showFilters = !this.showFilters;
  const filterModuleEl = this.$refs.filterModule.$el;
  if (this.showFilters) {
    filterModuleEl.classList.add("show");
  } else {
    filterModuleEl.classList.remove("show");
  }
},

async toggleMissingLastConsegnaFilter() {
  if (this.showOnlyMissingLastConsegna) {
    this.showOnlyMissingLastConsegna = false;
    this.missingLastConsegnaLoading = false;
    this.missingLastConsegnaRequestId += 1;
    return;
  }

  this.showOnlyMissingLastConsegna = true;
  await this.preloadMissingLastConsegnaPrograms(this.filteredUserData);
},

getLastProgramForUser(user) {
  const programs = this.buildProgramsForUser(user).filter(Boolean);
  if (!programs.length) return null;
  return programs[programs.length - 1] || null;
},

isMissingLastConsegnaProgramReady(user, alimentazione) {
  if (!user?.uid || !alimentazione) return true;
  if (Array.isArray(this.userProgramCache[user.uid])) return true;
  if (this.userProgramErrors[user.uid]) return true;
  return false;
},

shouldShowMissingLastConsegnaUser(rowBlock) {
  const user = rowBlock?.user;
  const programs = Array.isArray(rowBlock?.programs)
    ? rowBlock.programs.filter(Boolean)
    : [];
  if (!user || !programs.length) return false;

  const latestProgram = programs[programs.length - 1] || null;
  if (!latestProgram) return false;
  if (this.isConsegnaNotAvailable(latestProgram)) return false;
  if (!this.isMissingLastConsegnaProgramReady(user, latestProgram)) return false;

  return !this.isConsegnaConfirmed(user, latestProgram);
},

getMissingLastConsegnaLoadTargets(users = this.filteredUserData) {
  const targets = [];
  const seen = new Set();
  const source = Array.isArray(users) ? users : [];

  source.forEach((user) => {
    const latestProgram = this.getLastProgramForUser(user);
    const uid = user?.uid;
    if (!uid || !latestProgram) return;
    if (this.isConsegnaNotAvailable(latestProgram)) return;
    if (seen.has(uid)) return;
    if (Array.isArray(this.userProgramCache[uid])) return;
    if (this.userProgramLoading[uid]) return;
    if (this.userProgramErrors[uid]) return;
    seen.add(uid);
    targets.push(uid);
  });

  return targets;
},

async preloadMissingLastConsegnaPrograms(users = this.filteredUserData) {
  if (!this.showOnlyMissingLastConsegna) return;

  const requestId = ++this.missingLastConsegnaRequestId;
  const targets = this.getMissingLastConsegnaLoadTargets(users);

  if (!targets.length) {
    if (requestId === this.missingLastConsegnaRequestId) {
      this.missingLastConsegnaLoading = false;
    }
    return;
  }

  this.missingLastConsegnaLoading = true;

  try {
    await Promise.allSettled(
      targets.map((uid) => this.ensureUserProgramsLoaded(uid))
    );
  } finally {
    if (requestId === this.missingLastConsegnaRequestId) {
      this.missingLastConsegnaLoading = false;
    }
  }
},

refreshMissingLastConsegnaFilter(users = this.filteredUserData) {
  if (!this.showOnlyMissingLastConsegna) return;
  this.preloadMissingLastConsegnaPrograms(users).catch((error) => {
    console.error("Errore durante il caricamento lazy del filtro consegna:", error);
  });
},

prefetchProgramsForUsers(users) {
  if (!this.enableRealtimeFlagChecks) {
    return;
  }
  if (!Array.isArray(users) || !users.length) {
    return;
  }

  const prioritized = [];
  const fallback = [];

  users.forEach((user) => {
    const uid = user?.uid;
    if (!uid) return;
    const hasLinkedProgram =
      Array.isArray(user.alimentazioni) &&
      user.alimentazioni.some((alimentazione) => !!alimentazione?.percorsoId);
    if (hasLinkedProgram) {
      prioritized.push(uid);
    } else {
      fallback.push(uid);
    }
  });

  const ordered = [...prioritized, ...fallback];
  const selected = [];
  const seen = new Set();

  for (const uid of ordered) {
    if (!uid || seen.has(uid)) continue;
    seen.add(uid);
    if (Array.isArray(this.userProgramCache[uid])) continue;
    if (this.userProgramLoading[uid]) continue;
    selected.push(uid);
    if (selected.length >= this.programPrefetchLimit) break;
  }

  selected.forEach((uid) => {
    this.ensureUserProgramsLoaded(uid);
  });
},

async ensureUserProgramsLoaded(userUid) {
  if (!userUid) return;
  if (Array.isArray(this.userProgramCache[userUid])) return;
  if (this.userProgramLoading[userUid]) return;

  this.userProgramLoading = {
    ...this.userProgramLoading,
    [userUid]: true,
  };

  try {
    const db = getFirestore();
    const percorsiQuery = query(collection(db, "percorsi"), where("uid", "==", userUid));
    const snapshot = await getDocs(percorsiQuery);
    const normalized = snapshot.docs.map((docSnap) => this.normalizePercorsoSnapshot(docSnap));
    this.userProgramCache = {
      ...this.userProgramCache,
      [userUid]: normalized,
    };

    if (this.userProgramErrors[userUid]) {
      const nextErrors = { ...this.userProgramErrors };
      delete nextErrors[userUid];
      this.userProgramErrors = nextErrors;
    }
  } catch (error) {
    console.error(`Errore durante il caricamento dei percorsi per ${userUid}:`, error);
    this.userProgramErrors = {
      ...this.userProgramErrors,
      [userUid]: "Impossibile caricare i programmi.",
    };
  } finally {
    const nextLoading = { ...this.userProgramLoading };
    delete nextLoading[userUid];
    this.userProgramLoading = nextLoading;
  }
},

normalizePercorsoSnapshot(docSnap) {
  if (!docSnap) return null;
  const data = docSnap.data ? docSnap.data() || {} : {};
  const steps = Array.isArray(data.steps)
    ? data.steps.map((step) => ({ ...step }))
    : [];
  const consegnaIndex = steps.findIndex((step) => stepKeyFromName(step?.name) === "consegna");

  return {
    id: docSnap.id,
    title: data.title || "",
    productName: data.productName || "",
    sequenceGroupId: data.sequenceGroupId || null,
    sequenceIndex: data.sequenceIndex ?? null,
    sequenceTotal: data.sequenceTotal ?? null,
    consulenzeOnly: !!data.consulenzeOnly,
    steps,
    consegnaIndex,
    consegnaStep: consegnaIndex >= 0 ? { ...steps[consegnaIndex] } : null,
  };
},

formatProgramOptionLabel(percorso) {
  if (!percorso) return "Programma";
  const baseTitle = percorso.title || percorso.productName || "Programma";
  const normalizedTitle = String(baseTitle).trim() || "Programma";
  const index = Number(percorso.sequenceIndex) || null;
  const total = Number(percorso.sequenceTotal) || null;

  if (index && total) {
    return `${normalizedTitle} · #${index}/${total}`;
  }
  if (index) {
    return `${normalizedTitle} · #${index}`;
  }
  return normalizedTitle;
},

getUserProgramOptions(userUid) {
  const list = this.userProgramCache[userUid];
  if (!Array.isArray(list) || !list.length) {
    return [];
  }
  return list.map((percorso) => ({
    id: percorso.id,
    label: this.formatProgramOptionLabel(percorso),
  }));
},

hasProgramOption(userUid, percorsoId) {
  if (!percorsoId) return false;
  const options = this.getUserProgramOptions(userUid);
  return options.some((option) => option.id === percorsoId);
},

getPercorsoById(userUid, percorsoId) {
  if (!percorsoId) return null;
  const list = this.userProgramCache[userUid];
  if (!Array.isArray(list)) return null;
  return list.find((percorso) => percorso.id === percorsoId) || null;
},

isUserProgramsLoading(userUid) {
  return !!this.userProgramLoading[userUid];
},

programSelectPlaceholder(userUid) {
  if (!userUid) return "UID mancante";
  if (this.isUserProgramsLoading(userUid)) {
    return "Caricamento programmi…";
  }
  const options = this.getUserProgramOptions(userUid);
  return options.length ? "Seleziona programma" : "Nessun programma disponibile";
},

programLinkFallbackLabel(userUid) {
  return this.isUserProgramsLoading(userUid)
    ? "Programma collegato…"
    : "Programma collegato non più disponibile";
},

getIntegrazioneSummary(alimentazione) {
  return getIntegrationSummary(alimentazione);
},

getIntegrazioneButtonLabel(alimentazione) {
  return getIntegrationLabel(alimentazione);
},

openIntegrazioneModal(docId, alimentazione) {
  if (!this.canEdit || !alimentazione?.id) return;
  const user = this.userData.find((item) => item.id === docId);
  if (!user?.uid) return;
  this.integrazioneModal = {
    userId: user.uid,
    inviiDocId: docId,
    alimentazioneId: alimentazione.id,
    entry: alimentazione,
  };
},

async saveIntegrationWithPendingChanges(payload) {
  const docId = this.integrazioneModal?.inviiDocId;
  if (!this.canEdit || !docId || payload.inviiDocId !== docId ||
      payload.userId !== this.integrazioneModal.userId ||
      payload.alimentazioneId !== this.integrazioneModal.alimentazioneId) {
    throw new Error("Impossibile salvare: riapri l'integrazione dell'utente.");
  }
  return this.enqueueUserSave(docId, async () => {
    // Capture at save time, after any earlier save has acknowledged its edits.
    const pendingChanges = snapshotInviiPendingChanges(this.editedFields[docId]);
    const result = await saveIntegrationAssignment({ ...payload, pendingChanges });
    this.applyCommittedInviiChanges(docId, result.inviiPatch, result.committedChanges);
    return result;
  });
},

enqueueUserSave(docId, operation) {
  const previous = this.userSaveQueues[docId] || Promise.resolve();
  const queued = previous.catch(() => {}).then(operation);
  const tracked = queued.finally(() => {
    if (this.userSaveQueues[docId] === tracked) delete this.userSaveQueues[docId];
  });
  this.userSaveQueues[docId] = tracked;
  return tracked;
},

applyCommittedInviiChanges(docId, patch, committedChanges = {}) {
  if (patch) {
    [this.userData, this.filteredUserData, this.savedUserData].forEach((users) => {
      this.updateLocalUser(users, docId, patch);
    });
  }
  const remaining = this.editedFields[docId];
  if (remaining) {
    Object.entries(committedChanges).forEach(([key, value]) => {
      if (value && Object.getPrototypeOf(value) === Object.prototype) {
        Object.entries(value).forEach(([field, fieldValue]) => {
          if (remaining[key] && Object.prototype.hasOwnProperty.call(remaining[key], field) &&
              JSON.stringify(remaining[key][field]) === JSON.stringify(fieldValue)) {
            delete remaining[key][field];
          }
        });
        if (remaining[key] && !Object.keys(remaining[key]).length) delete remaining[key];
      } else if (JSON.stringify(remaining[key]) === JSON.stringify(value)) {
        delete remaining[key];
      }
    });
    if (!Object.keys(remaining).length) delete this.editedFields[docId];
  }
  [this.userData, this.filteredUserData, this.savedUserData].forEach((users) => {
    this.applyPendingEditsToCollection(users, docId);
  });
  this.queueFilterRefresh();
},

onIntegrationSaved(entry) {
  const uid = this.integrazioneModal?.userId;
  if (!uid || !entry?.id) return;
  [this.userData, this.filteredUserData, this.savedUserData].forEach((users) => {
    users.filter((user) => user.uid === uid).forEach((user) => {
      const existing = user.alimentazioni?.find((item) => item.id === entry.id);
      if (existing) this.updateLocalAlimentazione(users, user.id, entry.id, preserveIntegrationFields(existing, entry));
    });
  });
  this.integrazioneModal = null;
},

linkedProgramFallbackLabel(userUid, alimentazione) {
  if (alimentazione) {
    const title = (alimentazione.percorsoTitle || "").trim();
    const index = Number(alimentazione.percorsoSequenceIndex);
    const total = Number(alimentazione.percorsoSequenceTotal);
    const suffix =
      Number.isFinite(index) && index > 0
        ? total && Number.isFinite(total) && total > 0
          ? `#${index}/${total}`
          : `#${index}`
        : "";
    const composed = [title, suffix].filter(Boolean).join(" · ");
    if (composed) {
      return composed;
    }
  }
  return this.programLinkFallbackLabel(userUid);
},

normalizeInvioDeliveryTargetMode(rawMode) {
  return rawMode === "next" || rawMode === "current" ? rawMode : null;
},

isLegacyCurrentDeliveryCheck(alimentazione) {
  if (!alimentazione) return false;
  const key = (alimentazione.invioStepKey || "").toLowerCase();
  if (key !== "check_finale") return false;
  const stepIndex = Number(alimentazione.invioStepIndex);
  return Number.isFinite(stepIndex) && stepIndex === 0;
},

getInvioDeliveryTargetMode(alimentazione) {
  if (!alimentazione) return "current";
  const key = (alimentazione.invioStepKey || "").toLowerCase();
  if (key !== "check_finale") return "current";
  const explicitMode = this.normalizeInvioDeliveryTargetMode(alimentazione.invioDeliveryTargetMode);
  if (explicitMode) return explicitMode;
  return this.isLegacyCurrentDeliveryCheck(alimentazione) ? "current" : "next";
},

getInvioExpectedTargetSequenceIndex(alimentazione) {
  if (!alimentazione) return null;
  const deliveryMode = this.getInvioDeliveryTargetMode(alimentazione);
  const sourceIndex = Number(alimentazione.invioStepSequenceIndex);
  const sourceTotal = Number(alimentazione.invioStepSequenceTotal);

  if (Number.isFinite(sourceIndex) && sourceIndex > 0) {
    if (
      deliveryMode === "next" &&
      Number.isFinite(sourceTotal) &&
      sourceTotal > 0 &&
      sourceIndex < sourceTotal
    ) {
      return sourceIndex + 1;
    }
    return sourceIndex;
  }

  const linkedIndex = Number(alimentazione.percorsoSequenceIndex);
  return Number.isFinite(linkedIndex) && linkedIndex > 0 ? linkedIndex : null;
},

getInvioExpectedTargetSequenceTotal(alimentazione) {
  if (!alimentazione) return null;
  const sourceTotal = Number(alimentazione.invioStepSequenceTotal);
  if (Number.isFinite(sourceTotal) && sourceTotal > 0) {
    return sourceTotal;
  }
  const linkedTotal = Number(alimentazione.percorsoSequenceTotal);
  return Number.isFinite(linkedTotal) && linkedTotal > 0 ? linkedTotal : null;
},

resolveLinkedPercorso(rowUser, alimentazione) {
  const userUid = rowUser?.uid;
  const percorsoId = alimentazione?.percorsoId;
  if (!userUid) return null;
  const list = this.userProgramCache[userUid];
  const linked = percorsoId ? this.getPercorsoById(userUid, percorsoId) : null;
  if (!Array.isArray(list) || !list.length) return linked;

  const expectedIndex = this.getInvioExpectedTargetSequenceIndex(alimentazione);
  const expectedTotal = this.getInvioExpectedTargetSequenceTotal(alimentazione);
  if (!Number.isFinite(expectedIndex) || expectedIndex <= 0) return linked;

  const candidateFilter = (item) => {
    if (!item || item.consulenzeOnly) return false;
    const idx = Number(item.sequenceIndex);
    const tot = Number(item.sequenceTotal);
    if (!Number.isFinite(idx) || idx !== expectedIndex) return false;
    if (Number.isFinite(expectedTotal) && Number.isFinite(tot) && tot !== expectedTotal) return false;
    return true;
  };

  if (linked && candidateFilter(linked)) return linked;

  let candidates = list.filter(candidateFilter);
  if (linked?.sequenceGroupId) {
    const sameGroup = candidates.filter(
      (item) => (item.sequenceGroupId || null) === (linked.sequenceGroupId || null)
    );
    if (sameGroup.length === 1) return sameGroup[0];
    if (sameGroup.length > 1) return linked;
  }

  if (candidates.length === 1) return candidates[0];
  return linked;
},

hasStoredTargetMismatch(alimentazione, percorso) {
  if (!alimentazione || !percorso) return false;
  const storedId = alimentazione.percorsoId || null;
  const resolvedId = percorso.id || null;
  if (storedId !== resolvedId) return true;

  const storedIndex = Number(alimentazione.percorsoSequenceIndex);
  const resolvedIndex = Number(percorso.sequenceIndex);
  if (
    Number.isFinite(storedIndex) &&
    storedIndex > 0 &&
    Number.isFinite(resolvedIndex) &&
    resolvedIndex > 0 &&
    storedIndex !== resolvedIndex
  ) {
    return true;
  }

  const storedTotal = Number(alimentazione.percorsoSequenceTotal);
  const resolvedTotal = Number(percorso.sequenceTotal);
  if (
    Number.isFinite(storedTotal) &&
    storedTotal > 0 &&
    Number.isFinite(resolvedTotal) &&
    resolvedTotal > 0 &&
    storedTotal !== resolvedTotal
  ) {
    return true;
  }

  return false;
},

buildResolvedInvioLinkPatch(alimentazione, percorso) {
  if (!alimentazione) return null;
  const patch = {};
  const normalizedDeliveryMode = this.getInvioDeliveryTargetMode(alimentazione);

  if ((alimentazione.invioDeliveryTargetMode || null) !== normalizedDeliveryMode) {
    patch.invioDeliveryTargetMode = normalizedDeliveryMode;
  }

  if (percorso && this.hasStoredTargetMismatch(alimentazione, percorso)) {
    patch.percorsoId = percorso.id || null;
    patch.percorsoTitle =
      (percorso.title || percorso.productName || alimentazione.percorsoTitle || "").trim() || null;
    patch.percorsoSequenceIndex =
      Number.isFinite(Number(percorso.sequenceIndex)) && Number(percorso.sequenceIndex) > 0
        ? Number(percorso.sequenceIndex)
        : null;
    patch.percorsoSequenceTotal =
      Number.isFinite(Number(percorso.sequenceTotal)) && Number(percorso.sequenceTotal) > 0
        ? Number(percorso.sequenceTotal)
        : null;
  }

  return Object.keys(patch).length ? patch : null;
},

isConsegnaConfirmed(rowUser, alimentazione) {
  const userUid = rowUser?.uid;
  const cachedPrograms = userUid ? this.userProgramCache[userUid] : null;
  const linked = this.resolveLinkedPercorso(rowUser, alimentazione);
  if (linked && typeof linked.consegnaIndex === "number" && linked.consegnaIndex >= 0) {
    return !!linked.consegnaStep?.done;
  }
  if (Array.isArray(cachedPrograms)) {
    return false;
  }
  return !!alimentazione?.consegnaConfirmed;
},

isProgCustomEnabled(rowUser, alimentazione) {
  const userUid = rowUser?.uid;
  const cachedPrograms = userUid ? this.userProgramCache[userUid] : null;
  const linked = this.resolveLinkedPercorso(rowUser, alimentazione);
  if (linked && typeof linked.consegnaIndex === "number" && linked.consegnaIndex >= 0) {
    return !!linked.consegnaStep?.progCustomizzato;
  }
  if (Array.isArray(cachedPrograms)) {
    return false;
  }
  return !!alimentazione?.progCustomizzato;
},

hasInvioStepRef(alimentazione) {
  if (!alimentazione) return false;
  const key = (alimentazione.invioStepKey || "").trim();
  const label = (alimentazione.invioStepLabel || "").trim();
  return !!key || !!label;
},

getInvioProgramName(rowUser, alimentazione) {
  const linked = this.resolveLinkedPercorso(rowUser, alimentazione);
  if (linked) {
    const fromLinked = (linked.title || linked.productName || "").trim();
    if (fromLinked) return fromLinked;
  }
  if (!alimentazione) return "Programma";
  const title = (alimentazione.percorsoTitle || "").trim();
  return title || "Programma";
},

getInvioProgramHeader(rowUser, alimentazione) {
  const name = this.getInvioProgramName(rowUser, alimentazione);
  if (!alimentazione) return name;
  const linked = this.resolveLinkedPercorso(rowUser, alimentazione);
  const index = Number(linked?.sequenceIndex ?? alimentazione?.percorsoSequenceIndex);
  const total = Number(linked?.sequenceTotal ?? alimentazione?.percorsoSequenceTotal);
  if (Number.isFinite(index) && index > 0 && Number.isFinite(total) && total > 0) {
    return `${name} - Percorso ${index}/${total}`;
  }
  if (Number.isFinite(index) && index > 0) {
    return `${name} - Percorso ${index}`;
  }
  return name;
},

isConsegnaNotAvailable(alimentazione) {
  if (!alimentazione) return true;
  const key = (alimentazione.invioStepKey || "").toLowerCase();
  if (key !== "check_finale") return false;
  if (this.getInvioDeliveryTargetMode(alimentazione) !== "next") return false;
  const index = Number(alimentazione.invioStepSequenceIndex);
  const total = Number(alimentazione.invioStepSequenceTotal);
  if (!Number.isFinite(index) || !Number.isFinite(total)) return false;
  return index >= total;
},

isResolvedTargetAligned(alimentazione, percorso) {
  if (!alimentazione || !percorso) return true;
  const expectedSequenceIndex = this.getInvioExpectedTargetSequenceIndex(alimentazione);
  if (!Number.isFinite(expectedSequenceIndex) || expectedSequenceIndex <= 0) return true;
  const targetSequenceIndex = Number(percorso.sequenceIndex);
  if (!Number.isFinite(targetSequenceIndex) || targetSequenceIndex <= 0) return true;
  return targetSequenceIndex === expectedSequenceIndex;
},

isConsegnaDisabled(rowUser, alimentazione) {
  if (!rowUser || !alimentazione) return true;
  if (this.isConsegnaNotAvailable(alimentazione)) return true;
  const linked = this.resolveLinkedPercorso(rowUser, alimentazione);
  const targetPercorsoId = linked?.id || alimentazione.percorsoId;
  if (!targetPercorsoId) return true;
  const list = this.userProgramCache[rowUser.uid];
  if (Array.isArray(list) && !list.some((item) => item.id === targetPercorsoId)) return true;
  return this.isConsegnaSaving(rowUser.uid, targetPercorsoId);
},

isProgCustomDisabled(rowUser, alimentazione) {
  if (!rowUser || !alimentazione) return true;
  if (!rowUser.uid) return true;
  const linked = this.resolveLinkedPercorso(rowUser, alimentazione);
  const targetPercorsoId = linked?.id || alimentazione.percorsoId;
  if (!targetPercorsoId) return true;
  const list = this.userProgramCache[rowUser.uid];
  if (Array.isArray(list) && !list.some((item) => item.id === targetPercorsoId)) return true;
  return this.isProgCustomSaving(rowUser.uid, targetPercorsoId);
},

mapInvioStepLabel(stepKey) {
  const normalized = (stepKey || "").toLowerCase();
  if (!normalized) return "";
  if (normalized === "check_finale") return "check";
  if (normalized === "questionario") return "questionario";
  if (normalized === "feedback_programmi") return "feedback";
  return normalized.replace(/_/g, " ");
},

getInvioStepLabel(alimentazione) {
  if (!alimentazione) return "-";
  const rawLabel = (alimentazione.invioStepLabel || "").trim();
  const mappedLabel = rawLabel || this.mapInvioStepLabel(alimentazione.invioStepKey);
  const baseLabel = mappedLabel || "-";
  const rawIndex =
    alimentazione.invioStepSequenceIndex != null
      ? alimentazione.invioStepSequenceIndex
      : alimentazione.percorsoSequenceIndex;
  const rawTotal =
    alimentazione.invioStepSequenceTotal != null
      ? alimentazione.invioStepSequenceTotal
      : alimentazione.percorsoSequenceTotal;
  const index = Number(rawIndex);
  const total = Number(rawTotal);

  if (Number.isFinite(index) && index > 0 && Number.isFinite(total) && total > 0) {
    return `${baseLabel} ${index}/${total}`;
  }
  if (Number.isFinite(index) && index > 0) {
    return `${baseLabel} ${index}`;
  }
  return baseLabel || "-";
},

async toggleConsegnaFlag(rowUser, alimentazione, checked, event) {
  if (!rowUser || !alimentazione) return;
  const userDocId = rowUser.id;
  const userUid = rowUser.uid;
  if (!userDocId || !alimentazione.id) return;
  const previousValue = this.isConsegnaConfirmed(rowUser, alimentazione);
  const nextValue = !!checked;
  const resetCheckbox = () => {
    if (event && event.target) {
      event.target.checked = previousValue;
    }
  };

  if (nextValue === previousValue) {
    return;
  }
  if (this.isConsegnaNotAvailable(alimentazione)) {
    resetCheckbox();
    alert("Nessuna consegna prevista per questo check finale.");
    return;
  }
  if (!userUid) {
    resetCheckbox();
    alert("UID utente mancante per aggiornare la consegna.");
    return;
  }
  let cacheKey = "";

  try {
    const stamp = nextValue ? new Date().toISOString() : null;
    await this.ensureUserProgramsLoaded(userUid);
    const percorso =
      this.resolveLinkedPercorso(rowUser, alimentazione) ||
      this.getPercorsoById(userUid, alimentazione.percorsoId);
    if (!percorso) {
      resetCheckbox();
      alert("Programma non trovato. Aggiorna la pagina e riprova.");
      return;
    }
    const targetPercorsoId = percorso.id || alimentazione.percorsoId;
    if (!targetPercorsoId) {
      resetCheckbox();
      alert("Nessun programma collegato all'invio.");
      return;
    }
    if (!this.isResolvedTargetAligned(alimentazione, percorso)) {
      resetCheckbox();
      alert("Invio non allineato al programma collegato. Esegui prima la sincronizzazione dei link.");
      return;
    }
    if (typeof percorso.consegnaIndex !== "number" || percorso.consegnaIndex < 0) {
      resetCheckbox();
      alert("Il programma selezionato non ha lo step di consegna.");
      return;
    }
    if (nextValue && !percorso.consegnaStep?.progCustomizzato) {
      const confirmMessage =
        "Sei sicuro di fare la consegna? Il programma non risulta customizzato.";
      if (typeof window !== "undefined" && !window.confirm(confirmMessage)) {
        resetCheckbox();
        return;
      }
    }

    cacheKey = this.getConsegnaSavingKey(userUid, targetPercorsoId);
    if (cacheKey) {
      this.consegnaSavingState = {
        ...this.consegnaSavingState,
        [cacheKey]: true,
      };
    }

    await setStepDone(targetPercorsoId, percorso.consegnaIndex, nextValue);
    this.updateCachedConsegnaState(userUid, targetPercorsoId, nextValue);

    this.applyConsegnaStateForUser(userDocId, {
      [targetPercorsoId]: {
        consegnaConfirmed: nextValue,
        consegnaConfirmedAt: stamp,
      },
    });
    this.clearBufferedConsegnaToggleByPercorso(userDocId, targetPercorsoId);
    if (this.hasStoredTargetMismatch(alimentazione, percorso)) {
      try {
        await this.forceMirrorFlagsCopyForUser(rowUser);
      } catch (mirrorError) {
        console.warn("Impossibile riallineare i metadati invio dopo la consegna:", mirrorError);
      }
    }
  } catch (error) {
    console.error("Errore durante l'aggiornamento della consegna:", error);
    resetCheckbox();
    alert("Errore durante il salvataggio della consegna. Riprova più tardi.");
  } finally {
    if (cacheKey) {
      const nextSaving = { ...this.consegnaSavingState };
      delete nextSaving[cacheKey];
      this.consegnaSavingState = nextSaving;
    }
  }
},

clearBufferedConsegnaToggleByPercorso(userDocId, percorsoId) {
  if (!userDocId || !percorsoId) return;
  const editsForUser = this.editedFields[userDocId];
  if (!editsForUser || typeof editsForUser !== "object") return;

  const currentUser = this.userData.find((user) => user.id === userDocId);
  const alimentazioni = Array.isArray(currentUser?.alimentazioni) ? currentUser.alimentazioni : [];

  Object.entries(editsForUser).forEach(([editId, editValue]) => {
    if (!editValue || typeof editValue !== "object") return;
    const entry = alimentazioni.find((alim) => alim.id === editId);
    if (!entry || entry.percorsoId !== percorsoId) return;
    delete editValue.consegnaConfirmed;
    delete editValue.consegnaConfirmedAt;
    if (!Object.keys(editValue).length) {
      delete editsForUser[editId];
    }
  });

  if (!Object.keys(editsForUser).length) {
    delete this.editedFields[userDocId];
  }
},

async toggleProgCustomFlag(rowUser, alimentazione, checked, event) {
  if (!rowUser || !alimentazione) return;
  const userDocId = rowUser.id;
  const userUid = rowUser.uid;
  if (!userDocId || !alimentazione.id) return;

  const previousValue = this.isProgCustomEnabled(rowUser, alimentazione);
  const resetCheckbox = () => {
    if (event && event.target) {
      event.target.checked = previousValue;
    }
  };

  if (!userUid) {
    resetCheckbox();
    alert("UID utente mancante per aggiornare il programma customizzato.");
    return;
  }

  const nextValue = !!checked;
  if (nextValue === previousValue) return;

  let cacheKey = "";

  try {
    await this.ensureUserProgramsLoaded(userUid);
    const percorso =
      this.resolveLinkedPercorso(rowUser, alimentazione) ||
      this.getPercorsoById(userUid, alimentazione.percorsoId);
    if (!percorso) {
      resetCheckbox();
      alert("Programma non trovato. Aggiorna la pagina e riprova.");
      return;
    }
    const targetPercorsoId = percorso.id || alimentazione.percorsoId;
    if (!targetPercorsoId) {
      resetCheckbox();
      alert("Nessun programma collegato all'invio.");
      return;
    }
    if (!this.isResolvedTargetAligned(alimentazione, percorso)) {
      resetCheckbox();
      alert("Invio non allineato al programma collegato. Esegui prima la sincronizzazione dei link.");
      return;
    }

    cacheKey = this.getProgCustomSavingKey(userUid, targetPercorsoId);
    if (cacheKey) {
      this.progCustomSavingState = {
        ...this.progCustomSavingState,
        [cacheKey]: true,
      };
    }

    const response = await setProgCustomFlag(targetPercorsoId, nextValue);
    const stateByPercorsoId = response?.stateByPercorsoId || {
      [targetPercorsoId]: {
        progCustomizzato: nextValue,
        progCustomizzatoAt: nextValue ? new Date().toISOString() : null,
      },
    };

    this.applyProgCustomStateForUser(userDocId, stateByPercorsoId);
    this.updateCachedProgCustomState(userUid, stateByPercorsoId);
    if (this.hasStoredTargetMismatch(alimentazione, percorso)) {
      try {
        await this.forceMirrorFlagsCopyForUser(rowUser);
      } catch (mirrorError) {
        console.warn("Impossibile riallineare i metadati invio dopo il flag custom:", mirrorError);
      }
    }
  } catch (error) {
    console.error("Errore durante l'aggiornamento del programma customizzato:", error);
    resetCheckbox();
    alert("Errore durante il salvataggio del programma customizzato. Riprova più tardi.");
  } finally {
    if (cacheKey) {
      const nextSaving = { ...this.progCustomSavingState };
      delete nextSaving[cacheKey];
      this.progCustomSavingState = nextSaving;
    }
  }
},

normalizeIsoValue(value) {
  if (!value) return null;
  if (typeof value?.toDate === "function") {
    try {
      const fromTs = value.toDate();
      if (fromTs instanceof Date && !Number.isNaN(fromTs.getTime())) {
        return fromTs.toISOString();
      }
      return null;
    } catch (error) {
      return null;
    }
  }
  if (typeof value?.toMillis === "function") {
    try {
      const fromMs = new Date(value.toMillis());
      return Number.isNaN(fromMs.getTime()) ? null : fromMs.toISOString();
    } catch (error) {
      return null;
    }
  }
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
},

resolveForcedMirrorState(rowUser, alimentazione) {
  const emptyState = {
    consegnaConfirmed: false,
    consegnaConfirmedAt: null,
    progCustomizzato: false,
    progCustomizzatoAt: null,
  };

  if (!rowUser?.uid || !alimentazione) return emptyState;

  const percorso =
    this.resolveLinkedPercorso(rowUser, alimentazione) ||
    this.getPercorsoById(rowUser.uid, alimentazione.percorsoId);
  if (!percorso) return emptyState;
  if (!this.isResolvedTargetAligned(alimentazione, percorso)) return emptyState;
  if (typeof percorso.consegnaIndex !== "number" || percorso.consegnaIndex < 0) return emptyState;

  const consegnaStep =
    percorso.consegnaStep ||
    (Array.isArray(percorso.steps) ? percorso.steps[percorso.consegnaIndex] : null);
  if (!consegnaStep || typeof consegnaStep !== "object") return emptyState;

  const consegnaConfirmed = !!consegnaStep.done;
  const consegnaConfirmedAt = consegnaConfirmed
    ? (this.normalizeIsoValue(consegnaStep.doneAt) || this.normalizeIsoValue(alimentazione.consegnaConfirmedAt))
    : null;
  const progCustomizzato = !!consegnaStep.progCustomizzato;
  const progCustomizzatoAt = progCustomizzato
    ? (
      this.normalizeIsoValue(consegnaStep.progCustomizzatoAt) ||
      this.normalizeIsoValue(alimentazione.progCustomizzatoAt)
    )
    : null;

  return {
    consegnaConfirmed,
    consegnaConfirmedAt,
    progCustomizzato,
    progCustomizzatoAt,
  };
},

buildForcedMirrorFlagsPatch(userUid, entries) {
  const rowUser = { uid: userUid };
  let changedCount = 0;

  const nextEntries = (Array.isArray(entries) ? entries : []).map((entry) => {
    if (!entry || typeof entry !== "object") return entry;
    const resolvedPercorso =
      this.resolveLinkedPercorso(rowUser, entry) ||
      this.getPercorsoById(userUid, entry.percorsoId);
    const nextState = this.resolveForcedMirrorState(rowUser, entry);
    const linkPatch = this.buildResolvedInvioLinkPatch(entry, resolvedPercorso);
    const sameLinkPatch = !linkPatch || Object.entries(linkPatch).every(
      ([field, value]) => entry?.[field] === value
    );

    const sameState =
      sameLinkPatch &&
      !!entry.consegnaConfirmed === !!nextState.consegnaConfirmed &&
      this.areTimestampsEqual(entry.consegnaConfirmedAt, nextState.consegnaConfirmedAt) &&
      !!entry.progCustomizzato === !!nextState.progCustomizzato &&
      this.areTimestampsEqual(entry.progCustomizzatoAt, nextState.progCustomizzatoAt);

    if (sameState) return entry;

    changedCount += 1;
    return {
      ...entry,
      ...(linkPatch || {}),
      consegnaConfirmed: !!nextState.consegnaConfirmed,
      consegnaConfirmedAt: nextState.consegnaConfirmedAt || null,
      progCustomizzato: !!nextState.progCustomizzato,
      progCustomizzatoAt: nextState.progCustomizzatoAt || null,
    };
  });

  return {
    changed: changedCount > 0,
    changedCount,
    entries: nextEntries,
  };
},

applyForcedMirrorFlagsLocal(userDocId, nextEntries) {
  if (!userDocId) return;
  const safeEntries = Array.isArray(nextEntries) ? nextEntries.map((entry) => ({ ...entry })) : [];

  const updateCollection = (collection) => {
    if (!Array.isArray(collection)) return;
    const userIndex = collection.findIndex((user) => user?.id === userDocId);
    if (userIndex < 0) return;
    const current = collection[userIndex] || {};
    collection.splice(userIndex, 1, {
      ...current,
      alimentazioni: safeEntries.map((entry) => ({ ...entry })),
    });
  };

  updateCollection(this.userData);
  updateCollection(this.savedUserData);
  updateCollection(this.filteredUserData);

  const editsForUser = this.editedFields[userDocId];
  if (editsForUser && typeof editsForUser === "object") {
    safeEntries.forEach((entry) => {
      const entryId = entry?.id;
      if (!entryId) return;
      const entryEdits = editsForUser[entryId];
      if (!entryEdits || typeof entryEdits !== "object") return;

      delete entryEdits.consegnaConfirmed;
      delete entryEdits.consegnaConfirmedAt;
      delete entryEdits.progCustomizzato;
      delete entryEdits.progCustomizzatoAt;
      if (!Object.keys(entryEdits).length) {
        delete editsForUser[entryId];
      }
    });

    if (!Object.keys(editsForUser).length) {
      delete this.editedFields[userDocId];
    }
  }

  this.queueFilterRefresh();
},

async forceMirrorFlagsCopyForUser(targetUser) {
  if (!targetUser) return { changed: false, changedEntries: 0, changedDocs: 0 };
  const userDocId = targetUser.id;
  const userUid = targetUser.uid || targetUser.id;
  if (!userDocId || !userUid) return { changed: false, changedEntries: 0, changedDocs: 0 };

  await this.ensureUserProgramsLoaded(userUid);

  const db = getFirestore();
  const inviiRef = doc(db, "inviidigiornata", userDocId);
  const alimentazioniRef = doc(db, "alimentazioni", userUid);

  let inviiEntries = Array.isArray(targetUser.alimentazioni)
    ? targetUser.alimentazioni.map((entry) => ({ ...entry }))
    : [];

  try {
    const inviiSnap = await getDoc(inviiRef);
    if (inviiSnap.exists()) {
      const rawInviiEntries = inviiSnap.data()?.alimentazioni;
      inviiEntries = Array.isArray(rawInviiEntries)
        ? rawInviiEntries.map((entry) => ({ ...entry }))
        : [];
    }
  } catch (error) {
    console.warn("forceMirrorFlagsCopyForUser: impossibile leggere inviidigiornata", error);
  }

  const inviiPatch = this.buildForcedMirrorFlagsPatch(userUid, inviiEntries);
  let changedEntries = inviiPatch.changedCount;
  let changedDocs = 0;

  if (inviiPatch.changed) {
    const savedEntries = await updateProtectedProgramDocument(inviiRef, {
      alimentazioni: inviiPatch.entries,
      ...buildLatestProgramMirror(inviiPatch.entries),
    });
    this.applyForcedMirrorFlagsLocal(userDocId, savedEntries);
    changedDocs += 1;
  }

  let alimentazioniEntries = [];
  let alimentazioniExists = false;
  try {
    const alimentazioniSnap = await getDoc(alimentazioniRef);
    alimentazioniExists = alimentazioniSnap.exists();
    if (alimentazioniExists) {
      const rawAlimentazioniEntries = alimentazioniSnap.data()?.alimentazioni;
      alimentazioniEntries = Array.isArray(rawAlimentazioniEntries)
        ? rawAlimentazioniEntries.map((entry) => ({ ...entry }))
        : [];
    }
  } catch (error) {
    console.warn("forceMirrorFlagsCopyForUser: impossibile leggere alimentazioni", error);
  }

  const baseAlimentazioniEntries = alimentazioniExists
    ? alimentazioniEntries
    : inviiPatch.entries;
  const alimentazioniPatch = this.buildForcedMirrorFlagsPatch(userUid, baseAlimentazioniEntries);
  changedEntries += alimentazioniPatch.changedCount;

  if (alimentazioniExists) {
    if (alimentazioniPatch.changed) {
      await updateProtectedProgramDocument(alimentazioniRef, { alimentazioni: alimentazioniPatch.entries });
      changedDocs += 1;
    }
  } else if (Array.isArray(alimentazioniPatch.entries) && alimentazioniPatch.entries.length) {
    await setDoc(
      alimentazioniRef,
      {
        userId: userUid,
        alimentazioni: alimentazioniPatch.entries,
      },
      { merge: true }
    );
    changedDocs += 1;
  }

  return {
    changed: changedEntries > 0,
    changedEntries,
    changedDocs,
  };
},

applyConsegnaStateForUser(userDocId, stateByPercorsoId) {
  if (!userDocId || !stateByPercorsoId || typeof stateByPercorsoId !== "object") return;
  const percorsoIds = new Set(Object.keys(stateByPercorsoId));
  if (!percorsoIds.size) return;

  const nowIso = new Date().toISOString();
  const normalizeAt = (state, currentAt) => {
    if (!state?.consegnaConfirmed) return null;
    return state.consegnaConfirmedAt || currentAt || nowIso;
  };

  const updateCollection = (collection) => {
    if (!Array.isArray(collection)) return;
    const userIndex = collection.findIndex((user) => user.id === userDocId);
    if (userIndex < 0) return;

    const user = collection[userIndex];
    const alimentazioni = Array.isArray(user.alimentazioni) ? user.alimentazioni : [];
    let changed = false;

    const nextAlimentazioni = alimentazioni.map((entry) => {
      if (!entry || typeof entry !== "object") return entry;
      const percorsoId = entry.percorsoId;
      if (!percorsoId || !percorsoIds.has(percorsoId)) return entry;

      const nextState = stateByPercorsoId[percorsoId];
      if (!nextState) return entry;

      const nextDone = !!nextState.consegnaConfirmed;
      const nextAt = normalizeAt(nextState, entry.consegnaConfirmedAt);
      const sameState =
        !!entry.consegnaConfirmed === nextDone &&
        this.areTimestampsEqual(entry.consegnaConfirmedAt, nextAt);

      if (sameState) return entry;
      changed = true;
      return {
        ...entry,
        consegnaConfirmed: nextDone,
        consegnaConfirmedAt: nextAt,
      };
    });

    if (!changed) return;

    collection.splice(userIndex, 1, {
      ...user,
      alimentazioni: nextAlimentazioni,
    });
  };

  [this.userData, this.filteredUserData, this.savedUserData].forEach(updateCollection);
  this.queueFilterRefresh();
},

applyProgCustomStateForUser(userDocId, stateByPercorsoId) {
  if (!userDocId || !stateByPercorsoId || typeof stateByPercorsoId !== "object") return;
  const percorsoIds = new Set(Object.keys(stateByPercorsoId));
  if (!percorsoIds.size) return;

  const nowIso = new Date().toISOString();
  const normalizeAt = (state, currentAt) => {
    if (!state?.progCustomizzato) return null;
    return state.progCustomizzatoAt || currentAt || nowIso;
  };

  const updateCollection = (collection) => {
    if (!Array.isArray(collection)) return;
    const userIndex = collection.findIndex((user) => user.id === userDocId);
    if (userIndex < 0) return;

    const user = collection[userIndex];
    const alimentazioni = Array.isArray(user.alimentazioni) ? user.alimentazioni : [];
    let changed = false;

    const nextAlimentazioni = alimentazioni.map((entry) => {
      if (!entry || typeof entry !== "object") return entry;
      const percorsoId = entry.percorsoId;
      if (!percorsoId || !percorsoIds.has(percorsoId)) return entry;

      const nextState = stateByPercorsoId[percorsoId];
      if (!nextState) return entry;

      const nextCustom = !!nextState.progCustomizzato;
      const nextAt = normalizeAt(nextState, entry.progCustomizzatoAt);
      const sameState =
        !!entry.progCustomizzato === nextCustom &&
        this.areTimestampsEqual(entry.progCustomizzatoAt, nextAt);

      if (sameState) return entry;
      changed = true;
      return {
        ...entry,
        progCustomizzato: nextCustom,
        progCustomizzatoAt: nextAt,
      };
    });

    if (!changed) return;

    collection.splice(userIndex, 1, {
      ...user,
      alimentazioni: nextAlimentazioni,
    });
  };

  [this.userData, this.filteredUserData, this.savedUserData].forEach(updateCollection);

  const currentUser = this.userData.find((user) => user.id === userDocId);
  const currentAlimentazioni = Array.isArray(currentUser?.alimentazioni)
    ? currentUser.alimentazioni
    : [];
  const editsForUser = this.editedFields[userDocId];
  if (editsForUser && typeof editsForUser === "object") {
    Object.entries(editsForUser).forEach(([editId, editValue]) => {
      if (!editValue || typeof editValue !== "object") return;
      const entry = currentAlimentazioni.find((alim) => alim.id === editId);
      if (!entry || !entry.percorsoId || !percorsoIds.has(entry.percorsoId)) return;
      delete editValue.progCustomizzato;
      delete editValue.progCustomizzatoAt;
      if (!Object.keys(editValue).length) {
        delete editsForUser[editId];
      }
    });

    if (!Object.keys(editsForUser).length) {
      delete this.editedFields[userDocId];
    }
  }

  this.queueFilterRefresh();
},

updateCachedProgCustomState(userUid, stateByPercorsoId) {
  if (!userUid || !stateByPercorsoId || typeof stateByPercorsoId !== "object") return;
  const list = this.userProgramCache[userUid];
  if (!Array.isArray(list) || !list.length) return;

  const nowIso = new Date().toISOString();
  let changed = false;

  const nextList = list.map((percorso) => {
    const nextState = stateByPercorsoId[percorso.id];
    if (!nextState) return percorso;
    if (typeof percorso.consegnaIndex !== "number" || percorso.consegnaIndex < 0) {
      return percorso;
    }

    const steps = Array.isArray(percorso.steps) ? percorso.steps.map((step) => ({ ...step })) : [];
    if (!steps[percorso.consegnaIndex]) return percorso;

    const currentStep = steps[percorso.consegnaIndex];
    const nextCustom = !!nextState.progCustomizzato;
    const nextCustomAt = nextCustom
      ? (nextState.progCustomizzatoAt || currentStep.progCustomizzatoAt || nowIso)
      : null;
    const sameState =
      !!currentStep.progCustomizzato === nextCustom &&
      this.areTimestampsEqual(currentStep.progCustomizzatoAt, nextCustomAt);

    if (sameState) return percorso;

    steps[percorso.consegnaIndex] = {
      ...currentStep,
      progCustomizzato: nextCustom,
      progCustomizzatoAt: nextCustomAt,
    };
    changed = true;

    return {
      ...percorso,
      steps,
      consegnaStep: { ...(steps[percorso.consegnaIndex] || {}) },
    };
  });

  if (!changed) return;

  this.userProgramCache = {
    ...this.userProgramCache,
    [userUid]: nextList,
  };
},

handleProgramLinkChange(userDocId, alimentazioneId, rawValue) {
  const normalized = rawValue || null;
  this.updateField(userDocId, alimentazioneId, "percorsoId", normalized);
},

getProgCustomSavingKey(userUid, percorsoId) {
  if (!userUid || !percorsoId) return "";
  return `${userUid}__${percorsoId}`;
},

isProgCustomSaving(userUid, percorsoId) {
  const key = this.getProgCustomSavingKey(userUid, percorsoId);
  if (!key) return false;
  return !!this.progCustomSavingState[key];
},

getConsegnaSavingKey(userUid, percorsoId) {
  if (!userUid || !percorsoId) return "";
  return `${userUid}__${percorsoId}`;
},

isConsegnaSaving(userUid, percorsoId) {
  const key = this.getConsegnaSavingKey(userUid, percorsoId);
  if (!key) return false;
  return !!this.consegnaSavingState[key];
},

getConsegnaStatusValue(userUid, percorsoId) {
  if (!percorsoId) return "";
  const percorso = this.getPercorsoById(userUid, percorsoId);
  if (!percorso) return "";
  if (typeof percorso.consegnaIndex !== "number" || percorso.consegnaIndex < 0) {
    return "";
  }
  return percorso.consegnaStep?.done ? "Fatto" : "Da fare";
},

getConsegnaState(userUid, percorsoId) {
  if (!percorsoId) return "missing";
  const list = this.userProgramCache[userUid];
  if (!Array.isArray(list)) {
    return this.isUserProgramsLoading(userUid) ? "pending" : "pending";
  }
  const percorso = list.find((item) => item.id === percorsoId);
  if (!percorso) {
    if (this.isUserProgramsLoading(userUid)) {
      return "pending";
    }
    if (this.userProgramErrors[userUid]) {
      return "error";
    }
    return "pending";
  }
  if (typeof percorso.consegnaIndex === "number" && percorso.consegnaIndex >= 0) {
    return "available";
  }
  return "missing";
},

async handleConsegnaStatusChange(rowUser, alimentazione, rawValue) {
  if (!rowUser || !alimentazione) return;
  const userUid = rowUser.uid;
  if (!userUid) {
    alert("Impossibile determinare l'utente da aggiornare.");
    return;
  }
  const percorsoId = alimentazione.percorsoId;
  if (!percorsoId) {
    alert("Collega prima un programma per aggiornare la consegna.");
    return;
  }

  await this.ensureUserProgramsLoaded(userUid);
  const percorso = this.getPercorsoById(userUid, percorsoId);
  if (!percorso) {
    alert("Programma non trovato. Aggiorna la pagina e riprova.");
    return;
  }
  if (typeof percorso.consegnaIndex !== "number" || percorso.consegnaIndex < 0) {
    alert("Il programma selezionato non ha lo step di consegna.");
    return;
  }

  const wantDone = rawValue === "Fatto";
  const currentStatus = percorso.consegnaStep?.done ? "Fatto" : "Da fare";
  if (currentStatus === rawValue) {
    return;
  }

  const cacheKey = this.getConsegnaSavingKey(userUid, percorsoId);
  this.consegnaSavingState = {
    ...this.consegnaSavingState,
    [cacheKey]: true,
  };

  try {
    await setStepDone(percorsoId, percorso.consegnaIndex, wantDone);
    this.updateCachedConsegnaState(userUid, percorsoId, wantDone);
  } catch (error) {
    console.error("Errore durante l'aggiornamento della consegna:", error);
    alert("Errore durante il salvataggio della consegna. Riprova più tardi.");
  } finally {
    const nextSaving = { ...this.consegnaSavingState };
    delete nextSaving[cacheKey];
    this.consegnaSavingState = nextSaving;
  }
},

updateCachedConsegnaState(userUid, percorsoId, wantDone) {
  const list = this.userProgramCache[userUid];
  if (!Array.isArray(list)) return;
  const index = list.findIndex((percorso) => percorso.id === percorsoId);
  if (index === -1) return;

  const target = list[index];
  const stepIndex = target.consegnaIndex;
  const updatedSteps = Array.isArray(target.steps)
    ? target.steps.map((step, idx) => {
        if (idx !== stepIndex) return { ...step };
        return {
          ...step,
          done: wantDone,
          doneAt: wantDone ? new Date().toISOString() : null,
        };
      })
    : [];

  const updatedPercorso = {
    ...target,
    steps: updatedSteps,
    consegnaStep: stepIndex >= 0
      ? { ...(updatedSteps[stepIndex] || {}), done: wantDone }
      : target.consegnaStep,
  };

  const nextList = [...list];
  nextList.splice(index, 1, updatedPercorso);
  this.userProgramCache = {
    ...this.userProgramCache,
    [userUid]: nextList,
  };
},

getUserProgramError(userUid) {
  return this.userProgramErrors[userUid] || "";
},

buildProgramsForUser(user) {
  if (!user) return [null];
  const items = Array.isArray(user.alimentazioni) ? [...user.alimentazioni] : [];
  if (items.length === 0) {
    return [null];
  }

  const sortedItems = items.sort((a, b) => this.compareProgramDates(a, b));
  const maxPrograms = this.getMaxProgramsShown();
  if (sortedItems.length > maxPrograms) {
    const startIndex = Math.max(sortedItems.length - maxPrograms, 0);
    return sortedItems.slice(startIndex);
  }
  return sortedItems;
},

getMaxProgramsShown() {
  const override = Number(this.maxProgramsShownOverride);
  if (Number.isFinite(override) && override > 0) {
    return override;
  }
  return this.maxProgramsShown;
},

getLastAlimentazioneForFixedFilter(user) {
  const alimentazioni = Array.isArray(user?.alimentazioni)
    ? [...user.alimentazioni]
    : [];
  if (!alimentazioni.length) return null;
  alimentazioni.sort((a, b) => this.compareProgramDates(a, b));
  return alimentazioni[alimentazioni.length - 1] || null;
},

matchesFixedLastNoteFilter(user) {
  if (!this.fixedLastNoteFilter) return true;
  const lastAlimentazione = this.getLastAlimentazioneForFixedFilter(user);
  return !!lastAlimentazione && lastAlimentazione.noteselect === this.fixedLastNoteFilter;
},

applyFixedLastNoteFilter(users) {
  if (!this.fixedLastNoteFilter || !Array.isArray(users)) {
    return Array.isArray(users) ? users : [];
  }
  return users.filter((user) => this.matchesFixedLastNoteFilter(user));
},

getAlimentazioniForRender(user) {
  return this.buildProgramsForUser(user);
},

compareProgramDates(a, b) {
  const timeA = this.getProgramTimestamp(a?.dataCreazione);
  const timeB = this.getProgramTimestamp(b?.dataCreazione);
  return timeA - timeB;
},

getProgramTimestamp(value) {
  if (!value) return 0;
  if (typeof value?.toDate === "function") {
    return value.toDate().getTime();
  }
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? 0 : date.getTime();
},

areTimestampsEqual(a, b) {
  if (a === b) return true;
  if (!a || !b) return !a && !b;

  const toMillis = (val) => {
    if (!val) return null;
    if (typeof val.toMillis === "function") {
      return val.toMillis();
    }
    if (typeof val.toDate === "function") {
      return val.toDate().getTime();
    }
    const date = new Date(val);
    return Number.isNaN(date.getTime()) ? null : date.getTime();
  };

  const millisA = toMillis(a);
  const millisB = toMillis(b);
  return millisA !== null && millisB !== null && millisA === millisB;
},

getUserDetailsLink(userId) {
  if (!userId || !this.$router) return "#";
  const routeData = this.$router.resolve({
    name: "UserDetails",
    params: { userId },
  });
  return routeData?.href || "#";
},

queueFilterRefresh() {
  if (!this.$refs.filterModule) {
    return;
  }

  if (this.filterRefreshTimeout) {
    return;
  }

  this.filterRefreshTimeout = setTimeout(() => {
    this.filterRefreshTimeout = null;
    if (this.$refs.filterModule) {
      this.$refs.filterModule.applyFilters();
    }
  }, 200);
},

getResolvedRowColor(user) {
  if (!user) return "";
  const pending = this.rowColorPending[user.id];
  if (typeof pending !== "undefined") {
    return pending;
  }
  return user.rowColor || "";
},

handleRowColorChange(user, rawValue) {
  if (!user) return;
  if (!this.canEdit) return;
  const normalized = rawValue || "";
  const userId = user.id;

  this.lastFocusedUserId = userId;
  this.shouldPreserveFocus = true;

  this.rowColorPending = {
    ...this.rowColorPending,
    [userId]: normalized,
  };

  const updatePayload = { rowColor: normalized };
  [this.userData, this.filteredUserData, this.savedUserData].forEach((collection) => {
    this.updateLocalUser(collection, userId, updatePayload);
  });

  this.scheduleRowColorSave(userId);
  this.scrollUserRowIntoView(userId);
},

scheduleRowColorSave(userId) {
  if (this.rowColorSaveTimeouts[userId]) {
    clearTimeout(this.rowColorSaveTimeouts[userId]);
  }

  this.rowColorSaveTimeouts[userId] = setTimeout(() => {
    this.commitRowColorChange(userId);
  }, 250);
},

scrollUserRowIntoView(userId) {
  if (!userId) return;

  this.$nextTick(() => {
    const table = this.$refs.dataTable;
    if (!table) return;

    const safeId = String(userId).replace(/\\/g, "\\\\").replace(/"/g, '\\"');
    const row = table.querySelector(`[data-user-row="${safeId}"]`);

    if (!row) {
      this.shouldPreserveFocus = false;
      return;
    }

    const container = this.$refs.ticketsContainer;
    const rowRect = row.getBoundingClientRect();
    const fallbackRect = typeof window !== "undefined"
      ? { top: 0, bottom: window.innerHeight }
      : { top: 0, bottom: Number.POSITIVE_INFINITY };
    const containerRect = container
      ? container.getBoundingClientRect()
      : fallbackRect;

    const rowHeight = rowRect.height || row.offsetHeight || 0;
    const isWithinViewport =
      rowRect.top >= containerRect.top && rowRect.bottom <= containerRect.bottom;

    if (!isWithinViewport) {
      if (container && typeof container.scrollTop === "number") {
        const offsetTop = rowRect.top - containerRect.top + container.scrollTop;
        const targetScrollTop = offsetTop - container.clientHeight / 2 + rowHeight / 2;
        const maxScrollTop = Math.max(container.scrollHeight - container.clientHeight, 0);
        const clampedScrollTop = Math.min(Math.max(targetScrollTop, 0), maxScrollTop);
        container.scrollTop = clampedScrollTop;
      } else {
        row.scrollIntoView({ block: "nearest" });
      }
    }

    this.shouldPreserveFocus = false;
  });
},

async commitRowColorChange(userId) {
  if (!Object.prototype.hasOwnProperty.call(this.rowColorPending, userId)) {
    if (this.rowColorSaveTimeouts[userId]) {
      clearTimeout(this.rowColorSaveTimeouts[userId]);
      delete this.rowColorSaveTimeouts[userId];
    }
    return;
  }

  const pendingValue = this.rowColorPending[userId];
  const valueToPersist = pendingValue || "";

  try {
    const db = getFirestore();
    const userRef = doc(db, "inviidigiornata", userId);
    await updateDoc(userRef, { rowColor: valueToPersist || null });
    const nextPending = { ...this.rowColorPending };
    delete nextPending[userId];
    this.rowColorPending = nextPending;
    this.queueFilterRefresh();
  } catch (error) {
    console.error(`Errore durante l'aggiornamento del colore per utente ${userId}:`, error);
  } finally {
    if (this.rowColorSaveTimeouts[userId]) {
      clearTimeout(this.rowColorSaveTimeouts[userId]);
      delete this.rowColorSaveTimeouts[userId];
    }
  }
},




scheduleDataConsegnaSave(userId) {
  if (this.dataConsegnaSaveTimeouts[userId]) {
    clearTimeout(this.dataConsegnaSaveTimeouts[userId]);
  }

  this.dataConsegnaSaveTimeouts[userId] = setTimeout(() => {
    this.commitDataConsegnaChange(userId);
  }, 250);
},

async commitDataConsegnaChange(userId) {
  if (!Object.prototype.hasOwnProperty.call(this.dataConsegnaPending, userId)) {
    if (this.dataConsegnaSaveTimeouts[userId]) {
      clearTimeout(this.dataConsegnaSaveTimeouts[userId]);
      delete this.dataConsegnaSaveTimeouts[userId];
    }
    return;
  }

  const timestamp = this.dataConsegnaPending[userId] || null;

  try {
    const db = getFirestore();
    const userRef = doc(db, "inviidigiornata", userId);
    await updateDoc(userRef, { dataConsegna: timestamp || null });

    const nextPending = { ...this.dataConsegnaPending };
    delete nextPending[userId];
    this.dataConsegnaPending = nextPending;
    this.queueFilterRefresh();
  } catch (error) {
    console.error(`Errore durante l'aggiornamento di dataConsegna per utente ${userId}:`, error);
  } finally {
    if (this.dataConsegnaSaveTimeouts[userId]) {
      clearTimeout(this.dataConsegnaSaveTimeouts[userId]);
      delete this.dataConsegnaSaveTimeouts[userId];
    }
  }
},

scheduleAutoSave(userId) {
  if (!userId) return;

  if (this.autoSaveTimeouts[userId]) {
    clearTimeout(this.autoSaveTimeouts[userId]);
  }

  const timeoutId = setTimeout(() => {
    this.commitAutoSave(userId);
  }, 250);

  this.autoSaveTimeouts = {
    ...this.autoSaveTimeouts,
    [userId]: timeoutId,
  };
},

async commitAutoSave(userId) {
  if (!userId) return;

  const timeoutId = this.autoSaveTimeouts[userId];
  if (timeoutId) {
    clearTimeout(timeoutId);
    const nextTimeouts = { ...this.autoSaveTimeouts };
    delete nextTimeouts[userId];
    this.autoSaveTimeouts = nextTimeouts;
  }

  const pendingChanges = this.editedFields[userId];
  if (!pendingChanges || !Object.keys(pendingChanges).length) {
    return;
  }

  if (this.autoSaveInProgress[userId]) {
    this.autoSavePending = { ...this.autoSavePending, [userId]: true };
    return;
  }

  const targetUser =
    this.userData.find((user) => user.id === userId) ||
    this.savedUserData.find((user) => user.id === userId);

  if (!targetUser) {
    return;
  }

  this.autoSaveInProgress = { ...this.autoSaveInProgress, [userId]: true };

  try {
    await this.persistChangesForUser(targetUser);
  } catch (error) {
    console.error(`Errore durante l'autosalvataggio per l'utente ${userId}:`, error);
  } finally {
    const nextInProgress = { ...this.autoSaveInProgress };
    delete nextInProgress[userId];
    this.autoSaveInProgress = nextInProgress;

    if (this.autoSavePending[userId]) {
      const nextPending = { ...this.autoSavePending };
      delete nextPending[userId];
      this.autoSavePending = nextPending;
      this.scheduleAutoSave(userId);
    }
  }
},

listenToRealTimeUpdates() {
  const db = getFirestore();
  const collectionRef = collection(db, "inviidigiornata");

  onSnapshot(collectionRef, (snapshot) => {
    snapshot.docChanges().forEach((change) => {
      const docData = change.doc.data();
      const userId = change.doc.id;

      if (change.type === "modified") {
        console.log(`Modifiche ricevute in tempo reale per userId: ${userId}`);

        const userIndex = this.userData.findIndex((user) => user.id === userId);
        const shouldRestoreFocus = this.shouldPreserveFocus && this.lastFocusedUserId === userId;

        if (userIndex !== -1) {
          const localUserData = this.userData[userIndex];
          const savedUserIndex = this.savedUserData.findIndex((user) => user.id === userId);
          const savedUserData = savedUserIndex !== -1 ? this.savedUserData[savedUserIndex] : null;

          // Aggiorna solo i campi che non sono stati modificati localmente
          Object.entries(docData).forEach(([key, value]) => {
            if (key === "alimentazioni" && Array.isArray(value)) {
              // Gestione dell'array 'alimentazioni'
              if (!Array.isArray(localUserData.alimentazioni)) {
                localUserData.alimentazioni = [];
              }
              value.forEach((newAlim) => {
                const editedAlim = this.editedFields[userId]?.[newAlim.id];
                if (!editedAlim) {
                  // Aggiorna solo se non ci sono modifiche pendenti localmente
                  const localAlimIndex = localUserData.alimentazioni.findIndex(
                    (alim) => alim.id === newAlim.id
                  );
                  if (localAlimIndex !== -1) {
                    localUserData.alimentazioni[localAlimIndex] = newAlim;
                  } else {
                    // Se la nuova alimentazione non è presente, aggiungila
                    localUserData.alimentazioni.push(newAlim);
                  }
                }
              });

              if (savedUserData) {
                savedUserData.alimentazioni = Array.isArray(value)
                  ? value.map((item) => ({ ...item }))
                  : [];
              }
            } else {
              const skipRowColor =
                key === "rowColor" &&
                Object.prototype.hasOwnProperty.call(this.rowColorPending, userId);
              const skipDataConsegna =
                key === "dataConsegna" &&
                Object.prototype.hasOwnProperty.call(this.dataConsegnaPending, userId);

              if (!skipRowColor && !skipDataConsegna && !this.editedFields[userId]?.[key]) {
                // Aggiorna gli altri campi solo se non sono stati modificati localmente
                localUserData[key] = value;
              }

              if (
                savedUserData &&
                key !== "alimentazioni" &&
                !skipRowColor &&
                !skipDataConsegna
              ) {
                savedUserData[key] = value;
              }
            }
          });
        } else {
          // Se l'utente non è presente localmente, aggiungilo
          this.userData.push({ ...docData, id: userId });
          this.savedUserData.push({ ...docData, id: userId });
          if (!this.$refs.filterModule) {
            this.filteredUserData = [...this.userData];
          }
        }

        this.queueFilterRefresh();

        if (shouldRestoreFocus) {
          this.scrollUserRowIntoView(userId);
        }
      } else if (change.type === "added") {
        if (this.userData.some((user) => user.id === userId)) {
          return;
        }
        const newUser = { ...docData, id: userId };
        this.userData.push(newUser);
        this.savedUserData.push({ ...newUser });
        if (!this.$refs.filterModule) {
          this.filteredUserData = [...this.userData];
        } else {
          this.queueFilterRefresh();
        }
      }
    });
  });
},








    async savePhone(userId, phone) {
  try {
    if (!this.canEdit) return;
    if (!phone) return; // Se il campo è vuoto, non fare nulla

    const db = getFirestore();
    const inviiRef = doc(db, "inviidigiornata", userId);

    await updateDoc(inviiRef, { phone });
    console.log(`Numero di telefono salvato per utente: ${userId}`);
  } catch (error) {
    console.error("Errore durante il salvataggio del numero di telefono:", error);
    alert("Errore durante il salvataggio del numero di telefono.");
  }
},




    handleArrowNavigation(event, userIndex, alimentazioneIndex, fieldName) {
  const fields = ['allenamento', 'kcalalimentazioni', 'strategia', 'pianoIntegrazione'];
  const currentFieldIndex = fields.indexOf(fieldName);

  let nextUserIndex = userIndex;
  let nextAlimentazioneIndex = alimentazioneIndex;
  let nextFieldIndex = currentFieldIndex;

  switch (event.key) {
    case 'ArrowRight':
      if (currentFieldIndex < fields.length - 1) {
        nextFieldIndex++; // Vai al campo successivo nella stessa alimentazione
      }
      break;
    case 'ArrowLeft':
      if (currentFieldIndex > 0) {
        nextFieldIndex--; // Vai al campo precedente nella stessa alimentazione
      }
      break;
    case 'ArrowDown':
      if (alimentazioneIndex < this.userData[userIndex].alimentazioni.length - 1) {
        nextAlimentazioneIndex++; // Vai alla riga successiva
      }
      break;
    case 'ArrowUp':
      if (alimentazioneIndex > 0) {
        nextAlimentazioneIndex--; // Vai alla riga precedente
      }
      break;
    default:
      return; // Se non è una freccia, esci dalla funzione
  }

  // Trova il prossimo input e imposta il focus
  this.focusField(nextUserIndex, nextAlimentazioneIndex, fields[nextFieldIndex]);
},


focusField(userIndex, alimentazioneIndex, fieldName) {
  const dataTable = this.$refs.dataTable;
  if (!dataTable) return;

  const input = dataTable.querySelector(
    `tr:nth-child(${userIndex + 1}) ul li:nth-child(${alimentazioneIndex + 1}) .col-${fieldName} input`
  );

  if (input) {
    input.focus();
    input.select(); // Seleziona il contenuto per facilitare la modifica
  }
},



initAuth() {
  const auth = getAuth();
  auth.onAuthStateChanged(async (currentUser) => {
    if (currentUser) {
      this.currentUserId = currentUser.uid;

      const todayDate = new Date();
      const today = todayDate.toISOString().split("T")[0];
      const deliveryEnd = addBusinessDays(todayDate, 3).toISOString().split("T")[0];

      this.selectedFilters.deliveryStartDate = today;
      this.selectedFilters.deliveryEndDate = deliveryEnd;

      try {
        this.isLoading = true;
        await this.fetchUserData({
          limit: this.initialFetchLimit,
          markFullReady: false,
        });
      } catch (error) {
        console.error("Errore durante il caricamento iniziale:", error);
      }

      this.isBackgroundLoading = true;
      this.fetchUserData({
        markFullReady: true,
        silent: true,
      })
        .catch((error) => {
          console.error("Errore durante il caricamento completo:", error);
        })
        .finally(() => {
          this.isBackgroundLoading = false;
        });
    } else {
      console.warn("Utente non autenticato!");
    }
  });
},

async fetchUserData(options = {}) {
  const {
    limit: limitValue = null,
    markFullReady = true,
    silent = false,
  } = options;

  if (!silent) {
    this.isLoading = true;
  }

  try {
    const db = getFirestore();

    if (!this.currentUserRole && this.currentUserId) {
      const currentUserRef = doc(db, "users", this.currentUserId);
      const currentUserSnap = await getDoc(currentUserRef);

      if (currentUserSnap.exists()) {
        this.currentUserRole = currentUserSnap.data().userRole;
        this.canEdit = this.currentUserRole === "Amministratore";
      } else {
        console.error("Utente corrente non trovato!");
        this.canEdit = false;
      }
    }

    const baseCollection = collection(db, "inviidigiornata");
    const constraints = [orderBy("createdAt", "desc")];
    if (limitValue) {
      constraints.push(limitFn(limitValue));
    }
    const inviiQuery = query(baseCollection, ...constraints);
    const querySnapshot = await getDocs(inviiQuery);

    if (!silent) {
      await this.waitForFrame();
    }

    const processedUsers = this.prepareUserRecords(querySnapshot.docs);
    const orderedUsers = this.sortUsersByCreatedAt(processedUsers);
    this.applyLoadedUsers(orderedUsers);

    if (markFullReady) {
      this.totalUserCount = orderedUsers.length;
    } else if (!this.totalUserCount) {
      this.totalUserCount = orderedUsers.length;
    }
    this.isFullDataReady = markFullReady;
  } catch (error) {
    console.error("Errore durante il recupero dei dati:", error);
  } finally {
    if (!silent) {
      this.isLoading = false;
    }
  }

  return this.savedUserData;
},

sortUsersByCreatedAt(users) {
  return users
    .slice()
    .sort((a, b) => {
      const timeA = a?.createdAt instanceof Date ? a.createdAt.getTime() : new Date(a?.createdAt || 0).getTime();
      const timeB = b?.createdAt instanceof Date ? b.createdAt.getTime() : new Date(b?.createdAt || 0).getTime();

      if (Number.isNaN(timeA) && Number.isNaN(timeB)) return 0;
      if (Number.isNaN(timeA)) return 1;
      if (Number.isNaN(timeB)) return -1;
      return timeA - timeB;
    });
},

prepareUserRecords(docSnapshots) {
  return docSnapshots.map((docSnap) => {
    const data = docSnap.data() || {};
    const user = { ...data, id: docSnap.id };

    if (user.createdAt && typeof user.createdAt.toDate === "function") {
      user.createdAt = user.createdAt.toDate();
    } else if (!user.createdAt) {
      user.createdAt = null;
    }

    if (Array.isArray(user.alimentazioni)) {
      const clonedAlimentazioni = user.alimentazioni.map((alimentazione) => ({ ...alimentazione }));
      clonedAlimentazioni.sort((a, b) => {
        const dateA = a?.dataCreazione?.toDate
          ? a.dataCreazione.toDate()
          : new Date(a?.dataCreazione || 0);
        const dateB = b?.dataCreazione?.toDate
          ? b.dataCreazione.toDate()
          : new Date(b?.dataCreazione || 0);
        return dateA - dateB;
      });
      user.alimentazioni = clonedAlimentazioni;
    } else {
      user.alimentazioni = [];
    }

    return user;
  });
},

cloneUsersForEditing(users) {
  return users.map((user) => ({
    ...user,
    alimentazioni: Array.isArray(user.alimentazioni)
      ? user.alimentazioni.map((alimentazione) => ({ ...alimentazione }))
      : [],
  }));
},

applyLoadedUsers(users) {
  this.savedUserData = users;
  this.applyPendingEditsToCollection(this.savedUserData);

  this.userData = this.cloneUsersForEditing(this.savedUserData);
  this.applyPendingEditsToCollection(this.userData);

  if (this.$refs.filterModule && typeof this.$refs.filterModule.applyFilters === "function") {
    this.$nextTick(() => {
      this.$refs.filterModule.applyFilters();
    });
  } else {
    this.filteredUserData = this.applyFixedLastNoteFilter(this.userData);
    this.prefetchProgramsForUsers(this.filteredUserData);
    this.refreshMissingLastConsegnaFilter(this.filteredUserData);
  }
},

handleFilteredData(filteredSavedUsers) {
  if (!Array.isArray(filteredSavedUsers)) {
    this.filteredUserData = this.applyFixedLastNoteFilter(this.userData);
    this.prefetchProgramsForUsers(this.filteredUserData);
    this.refreshMissingLastConsegnaFilter(this.filteredUserData);
    return;
  }

  const userMap = new Map(this.userData.map((user) => [user.id, user]));
  this.filteredUserData = this.applyFixedLastNoteFilter(filteredSavedUsers)
    .map((savedUser) => userMap.get(savedUser.id))
    .filter(Boolean);
  this.prefetchProgramsForUsers(this.filteredUserData);
  this.refreshMissingLastConsegnaFilter(this.filteredUserData);

  if (this.shouldPreserveFocus && this.lastFocusedUserId) {
    this.scrollUserRowIntoView(this.lastFocusedUserId);
  } else {
    this.shouldPreserveFocus = false;
  }
},

handleFiltersChanged(rawFilters) {
  if (!rawFilters || typeof rawFilters !== "object") {
    return;
  }

  this.selectedFilters = {
    ...this.selectedFilters,
    ...rawFilters,
  };
},

applyPendingEditsToCollection(collection, userId = null) {
  if (!Array.isArray(collection) || !this.editedFields) return;

  const users = userId ? [collection.find((user) => user.id === userId)].filter(Boolean) : collection;
  users.forEach((user) => {
    const userEdits = this.editedFields[user.id];
    if (!userEdits) return;

    Object.entries(userEdits).forEach(([key, value]) => {
      const isAlimentazioneEdit =
        typeof value === "object" &&
        value !== null &&
        Array.isArray(user.alimentazioni) &&
        user.alimentazioni.some((alimentazione) => alimentazione.id === key);

      if (isAlimentazioneEdit) {
        const index = user.alimentazioni.findIndex((alimentazione) => alimentazione.id === key);
        if (index !== -1) {
          user.alimentazioni[index] = {
            ...user.alimentazioni[index],
            ...value,
          };
        }
      } else {
        user[key] = value;
      }
    });
  });
},









formatDateTime(date) {
  if (!date) return "Data non valida";

  if (date.toDate) {
    // Se è un Timestamp di Firestore
    const dateObj = date.toDate();
    return dateObj.toLocaleDateString("it-IT", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  if (typeof date === "string" || date instanceof Date) {
    // Se è una stringa o un oggetto Date
    const dateObj = new Date(date);
    return !isNaN(dateObj)
      ? dateObj.toLocaleDateString("it-IT", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })
      : "Data non valida";
  }

  console.warn("Formato data non riconosciuto in formatDateTime:", date);
  return "Data non valida";
},



formatDate(date) {
  if (!date) return 'Data non valida';
  if (date.toDate) {
    // Se è un Timestamp di Firestore
    return date.toDate().toLocaleDateString('it-IT', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  }
  if (typeof date === 'string' || date instanceof Date) {
    // Se è una stringa o un oggetto Date
    const dateObj = new Date(date);
    return !isNaN(dateObj)
      ? dateObj.toLocaleDateString('it-IT', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })
      : 'Data non valida';
  }
  console.warn('Formato data non riconosciuto in formatDate:', date);
  return 'Data non valida';
},



async deleteAlimentazione(userId, alimentazioneId) {
  if (!this.canEdit) return;
  if (!confirm("Sei sicuro di voler eliminare questo programma?")) {
    return;
  }

  this.isLoading = true;  // Attiva il loader prima di iniziare il processo

  try {
    const db = getFirestore();
    const userRef = doc(db, "inviidigiornata", userId);
    const userSnap = await getDoc(userRef);

    if (userSnap.exists()) {
      const userData = userSnap.data();
      const newAlimentazioni = userData.alimentazioni.filter(alim => alim.id !== alimentazioneId);

      await updateDoc(userRef, {
        alimentazioni: newAlimentazioni,
        ...buildLatestProgramMirror(newAlimentazioni),
      });
      console.log(`Alimentazione rimossa per utente: ${userId}`);

      // Aggiorna localmente i dati senza ricaricare dal server
      const userIndex = this.userData.findIndex(user => user.id === userId);
      if (userIndex !== -1) {
        this.userData[userIndex].alimentazioni = newAlimentazioni;
        this.filteredUserData = [...this.userData];

        await this.initAuth();  // Aggiorna lo stato dell'autenticazione se necessario
        await this.fetchUserData();  // Aggiorna i dati utente senza ricaricamento completo
        this.handleUserChange(userId); // Ristabilisce il focus sull'utente corrente
      }

      this.queueFilterRefresh();
    }

    alert("Programma eliminato con successo!");
  } catch (error) {
    console.error("Errore durante l'eliminazione dell'alimentazione:", error);
    alert("Errore durante l'eliminazione dell'alimentazione. Controlla i log per i dettagli.");
  } finally {
    this.isLoading = false;  // Disattiva il loader dopo aver completato il processo
  }
},








  async deleteUserData(uid) {
  if (!confirm("Sei sicuro di voler eliminare questo documento e la relativa alimentazione?")) {
    return;
  }

  try {
    const db = getFirestore();

    // Rimuovi il documento dalla collection 'inviidigiornata'
    const inviiQuerySnapshot = await getDocs(
      query(collection(db, "inviidigiornata"), where("uid", "==", uid))
    );

    if (!inviiQuerySnapshot.empty) {
      const inviiDoc = inviiQuerySnapshot.docs[0];
      await deleteDoc(doc(db, "inviidigiornata", inviiDoc.id));
      console.log(`Documento eliminato da 'inviidigiornata' per utente: ${uid}`);
    } else {
      console.warn(`Nessun documento trovato in 'inviidigiornata' per utente: ${uid}`);
    }

    // Rimuovi l'ultima alimentazione vuota dalla collection 'alimentazioni'
    const alimentazioniRef = doc(db, "alimentazioni", uid);
    const alimentazioniSnap = await getDoc(alimentazioniRef);

    if (alimentazioniSnap.exists()) {
      const alimentazioniData = alimentazioniSnap.data().alimentazioni || [];
      if (alimentazioniData.length > 0) {
        alimentazioniData.pop();
        await updateDoc(alimentazioniRef, { alimentazioni: alimentazioniData });
        console.log(`Alimentazione vuota rimossa da 'alimentazioni' per utente: ${uid}`);
      }
    }

    alert("Documento e alimentazione eliminati con successo!");

    // **Aggiorna i dati utente e il ruolo dopo l'eliminazione**
    await this.initAuth(); // Ricarica l'autenticazione
    await this.fetchUserData(); // Ricarica i dati utente
    this.queueFilterRefresh();
  } catch (error) {
    console.error("Errore durante l'eliminazione dei dati:", error);
    alert("Errore durante l'eliminazione dei dati. Controlla i log per i dettagli.");
  }
},







  // Ritorna una versione trasparente del colore scelto
  getTransparentColor(color) {
    const colors = {
      red: "rgba(255, 0, 0, 0.2)", // Rosso trasparente
      green: "rgba(0, 255, 0, 0.2)", // Verde trasparente
      blue: "rgba(0, 0, 255, 0.2)", // Blu trasparente
      yellow: "rgba(255, 255, 0, 0.2)", // Giallo trasparente
      orange: "rgba(255, 165, 0, 0.2)", // Arancione trasparente
      pink: "rgba(255, 192, 203, 0.2)", // Rosa trasparente
      protocollo: "rgba(255, 88, 0, 0.2)", // Rosa trasparente

    };
    return colors[color] || "transparent"; // Default: trasparente
  },





    async addAlimentazioneToUser(uid) {
  if (!uid) {
    alert("UID utente non valido per creare una nuova alimentazione.");
    return;
  }

  try {
    const db = getFirestore();

    // **Parte 1: Aggiorna o crea nella collection 'alimentazioni'**
    const alimentazioniRef = doc(db, "alimentazioni", uid); // Qui usiamo il `uid` come riferimento
    const alimentazioniSnap = await getDoc(alimentazioniRef);

    let alimentazioniData = [];
    if (alimentazioniSnap.exists()) {
      console.log("Documento alimentazioni trovato per utente:", uid);
      alimentazioniData = alimentazioniSnap.data().alimentazioni || [];
    } else {
      console.log("Documento alimentazioni NON trovato, verrà creato per utente:", uid);
    }

    // Creare una nuova alimentazione vuota
    const newAlimentazione = {
      dataCreazione: Timestamp.fromDate(new Date()), // Data attuale
      id: Date.now().toString(), // Genera un ID univoco basato sul timestamp corrente
      kcalalimentazioni: "",
      strategia: "",
      pianoIntegrazione: "",
      allenamento: "",
      freqallenamento: "",
      lavtrainer: "",
      lavorato: "",
      userId: uid, // Colleghiamo userId al `uid`
      percorsoId: null,
      percorsoTitle: null,
      percorsoSequenceIndex: null,
      percorsoSequenceTotal: null,
      invioStepKey: null,
      invioStepIndex: null,
      invioStepLabel: null,
      invioStepSequenceIndex: null,
      invioStepSequenceTotal: null,
      invioDeliveryTargetMode: null,
      consegnaConfirmed: false,
      consegnaConfirmedAt: null,
      progCustomizzato: false,
      progCustomizzatoAt: null,
      dataFileCaricato: null,
      dataSelezioneSI: null,
      nota1: "",
      nota2: "",
      videocall: "",
      linkAlimentazione: "",
      noteselect: "",
      nutrizionista: "",
      nutrizionistadiet: "",
      notetrainer: "",

    };

    // Aggiungi la nuova alimentazione
    alimentazioniData.push(newAlimentazione);

    // Aggiorna o crea il documento nella collection 'alimentazioni'
    if (alimentazioniSnap.exists()) {
      await updateProtectedProgramDocument(alimentazioniRef, { alimentazioni: alimentazioniData, userId: uid });
      console.log("Nuova alimentazione aggiunta in alimentazioni esistente per utente:", uid);
    } else {
      await setDoc(alimentazioniRef, { alimentazioni: alimentazioniData, userId: uid }); // Aggiungi anche il campo `userId`
      console.log("Nuovo documento creato in alimentazioni con nuova alimentazione per utente:", uid);
    }

    // **Parte 2: Aggiorna la collection 'inviidigiornata'**
    const inviiQuery = query(
      collection(db, "inviidigiornata"),
      where("uid", "==", uid) // Usa il campo `uid` per la query
    );
    const inviiSnap = await getDocs(inviiQuery);

    if (inviiSnap.empty) {
      console.error(`Documento inviidigiornata non trovato per uid: ${uid}`);
      alert("Documento inviidigiornata non trovato.");
      return;
    }

    const inviiDoc = inviiSnap.docs[0]; // Recupera il primo documento corrispondente
    const inviiData = inviiDoc.data();

    const alimentazioniInvii = inviiData.alimentazioni || [];
    alimentazioniInvii.push(newAlimentazione);

    await updateProtectedProgramDocument(doc(db, "inviidigiornata", inviiDoc.id), {
      alimentazioni: alimentazioniInvii,
      ...buildLatestProgramMirror(alimentazioniInvii),
    });
    console.log("Nuova alimentazione aggiunta in inviidigiornata per utente:", uid);

    alert("Nuova alimentazione aggiunta con successo!");
    this.fetchUserData(); // Aggiorna la tabella
    this.queueFilterRefresh();
  } catch (error) {
    console.error("Errore durante la creazione della nuova alimentazione:", error);
    alert("Errore durante l'aggiunta della nuova alimentazione.");
  }
},






triggerFileUpload(userUid, userDocId, alimentazioneId) {
  const fileInput = document.createElement("input");
  fileInput.type = "file";
  fileInput.accept = "application/pdf,image/jpeg,image/png";
  fileInput.onchange = (event) => {
    const file = event.target?.files?.[0];
    if (!file) return;
    this.setDropPreview(userDocId, alimentazioneId, this.formatDropPreviewName(file.name));
    this.uploadProgramFile(userUid, userDocId, alimentazioneId, file);
  };
  fileInput.click();
},

formatDropPreviewName(fileName) {
  if (!fileName) return "";
  const trimmed = fileName.trim();
  const maxLength = 36;
  return trimmed.length > maxLength ? `${trimmed.slice(0, maxLength - 3)}...` : trimmed;
},

waitForFrame() {
  return new Promise((resolve) => {
    if (typeof window !== "undefined" && typeof window.requestAnimationFrame === "function") {
      window.requestAnimationFrame(() => resolve());
    } else {
      setTimeout(resolve, 0);
    }
  });
},

handleDropZoneEnter(userDocId, alimentazioneId) {
  if (!this.canEdit) return;
  this.setDropZoneState(userDocId, alimentazioneId, true);
  this.setDropPreview(userDocId, alimentazioneId, "Rilascia qui per caricare");
},

handleDropZoneLeave(userDocId, alimentazioneId) {
  this.setDropZoneState(userDocId, alimentazioneId, false);
  if (!this.isUploading(userDocId, alimentazioneId)) {
    this.clearDropPreview(userDocId, alimentazioneId);
  }
},

handleFileDrop(userUid, userDocId, alimentazioneId, event) {
  if (!this.canEdit) return;
  this.handleDropZoneLeave(userDocId, alimentazioneId);
  if (this.isUploading(userDocId, alimentazioneId)) return;

  const files = event.dataTransfer?.files;
  if (!files || files.length === 0) return;

  const [file] = files;
  if (!file) return;

  this.setDropPreview(userDocId, alimentazioneId, this.formatDropPreviewName(file.name));
  this.uploadProgramFile(userUid, userDocId, alimentazioneId, file);
},

handleDropZoneClick(userUid, userDocId, alimentazioneId) {
  if (!this.canEdit || this.isUploading(userDocId, alimentazioneId)) return;
  this.triggerFileUpload(userUid, userDocId, alimentazioneId);
},

isDropZoneActive(userDocId, alimentazioneId) {
  const key = this.getDropZoneKey(userDocId, alimentazioneId);
  return !!this.activeDropZones[key];
},

setDropZoneState(userDocId, alimentazioneId, isActive) {
  const key = this.getDropZoneKey(userDocId, alimentazioneId);
  const nextState = { ...this.activeDropZones };
  if (isActive) {
    nextState[key] = true;
  } else {
    delete nextState[key];
  }
  this.activeDropZones = nextState;
},

getDropZoneKey(userDocId, alimentazioneId) {
  return `${userDocId}-${alimentazioneId}`;
},

getUploadMessage(userDocId, alimentazioneId) {
  const key = this.getDropZoneKey(userDocId, alimentazioneId);
  return this.uploadMessages[key] || null;
},

getDropPreview(userDocId, alimentazioneId) {
  const key = this.getDropZoneKey(userDocId, alimentazioneId);
  return this.dropPreviews[key] || "";
},

setDropPreview(userDocId, alimentazioneId, text) {
  const key = this.getDropZoneKey(userDocId, alimentazioneId);
  const nextPreviews = { ...this.dropPreviews };

  if (text) {
    nextPreviews[key] = text;
  } else {
    delete nextPreviews[key];
  }

  this.dropPreviews = nextPreviews;
},

clearDropPreview(userDocId, alimentazioneId) {
  this.setDropPreview(userDocId, alimentazioneId, "");
},

setUploadMessage(userDocId, alimentazioneId, message, options = {}) {
  const key = this.getDropZoneKey(userDocId, alimentazioneId);
  if (!message) {
    this.clearUploadMessage(userDocId, alimentazioneId);
    return;
  }
  const nextMessages = { ...this.uploadMessages, [key]: message };
  this.uploadMessages = nextMessages;

  const { autoHide = message?.type !== "loading", duration = 4000 } = options;

  if (this.uploadMessageTimeouts[key]) {
    clearTimeout(this.uploadMessageTimeouts[key]);
    delete this.uploadMessageTimeouts[key];
  }

  if (autoHide) {
    this.uploadMessageTimeouts[key] = setTimeout(() => {
      this.clearUploadMessage(userDocId, alimentazioneId);
    }, duration);
  }
},

clearUploadMessage(userDocId, alimentazioneId) {
  const key = this.getDropZoneKey(userDocId, alimentazioneId);
  const nextMessages = { ...this.uploadMessages };
  delete nextMessages[key];
  this.uploadMessages = nextMessages;

  if (this.uploadMessageTimeouts[key]) {
    clearTimeout(this.uploadMessageTimeouts[key]);
    delete this.uploadMessageTimeouts[key];
  }
},

isUploading(userDocId, alimentazioneId) {
  const key = this.getDropZoneKey(userDocId, alimentazioneId);
  return !!this.uploadingStates[key];
},

async uploadProgramFile(userUid, userDocId, alimentazioneId, file) {
  const maxSizeBytes = 10 * 1024 * 1024; // 10 MB
  if (file.size > maxSizeBytes) {
    this.setUploadMessage(userDocId, alimentazioneId, {
      text: "Il file selezionato supera i 10 MB. Seleziona un file più leggero.",
      type: "error",
    });
    this.setDropZoneState(userDocId, alimentazioneId, false);
    this.clearDropPreview(userDocId, alimentazioneId);
    return;
  }

  const fileType = file.type.includes("pdf")
    ? "pdf"
    : file.type.includes("png")
    ? "png"
    : file.type.includes("jpeg") || file.type.includes("jpg")
    ? "jpg"
    : null;

  if (!fileType) {
    this.setUploadMessage(userDocId, alimentazioneId, {
      text: "Sono consentiti solo file PDF o immagini JPG/PNG.",
      type: "error",
    });
    this.setDropZoneState(userDocId, alimentazioneId, false);
    this.clearDropPreview(userDocId, alimentazioneId);
    return;
  }

  const key = this.getDropZoneKey(userDocId, alimentazioneId);
  this.uploadingStates = { ...this.uploadingStates, [key]: true };
  this.setDropZoneState(userDocId, alimentazioneId, true);
  this.setUploadMessage(
    userDocId,
    alimentazioneId,
    {
      text: "Caricamento in corso…",
      type: "loading",
    },
    { autoHide: false }
  );

  try {
    const storage = getStorage();
    const safeFileName = `${Date.now()}_${file.name}`;
    const filePath = `alimentazioni/${userUid}/${alimentazioneId}/${safeFileName}`;
    const fileRef = storageRef(storage, filePath);
    await uploadBytes(fileRef, file);
    const fileUrl = await getDownloadURL(fileRef);
    const dataFileCaricato = Timestamp.fromDate(new Date());

    const db = getFirestore();

    // Aggiorna la collection 'alimentazioni'
    const alimentazioniRef = doc(db, "alimentazioni", userUid);
    const alimentazioniSnap = await getDoc(alimentazioniRef);
    if (alimentazioniSnap.exists()) {
      const alimentazioniData = alimentazioniSnap.data();
      const updatedAlimentazioni = (alimentazioniData.alimentazioni || []).map((alim) =>
        alim.id === alimentazioneId
          ? { ...alim, fileUrl, fileType, dataFileCaricato }
          : alim
      );
      await updateProtectedProgramDocument(alimentazioniRef, { alimentazioni: updatedAlimentazioni });
    } else {
      console.warn(`Documento 'alimentazioni' non trovato per utente ${userUid}. Nessun aggiornamento eseguito.`);
    }

    // Aggiorna la collection 'inviidigiornata'
    const inviiRef = doc(db, "inviidigiornata", userDocId);
    const inviiSnap = await getDoc(inviiRef);
    if (inviiSnap.exists()) {
      const inviiData = inviiSnap.data();
      const updatedInviiAlimentazioni = (inviiData.alimentazioni || []).map((alim) =>
        alim.id === alimentazioneId
          ? { ...alim, fileUrl, fileType, dataFileCaricato }
          : alim
      );
      await updateProtectedProgramDocument(inviiRef, {
        alimentazioni: updatedInviiAlimentazioni,
        ...buildLatestProgramMirror(updatedInviiAlimentazioni),
      });
    } else {
      console.warn(`Documento 'inviidigiornata' non trovato per utente ${userDocId}. Nessun aggiornamento eseguito.`);
    }

    const updatedFields = { fileUrl, fileType, dataFileCaricato };
    this.updateLocalAlimentazione(this.userData, userDocId, alimentazioneId, updatedFields);
    this.updateLocalAlimentazione(this.savedUserData, userDocId, alimentazioneId, updatedFields);
    this.updateLocalAlimentazione(this.filteredUserData, userDocId, alimentazioneId, updatedFields);

    this.queueFilterRefresh();

    this.setDropPreview(
      userDocId,
      alimentazioneId,
      `Caricato: ${this.formatDropPreviewName(file.name)}`
    );
    this.setUploadMessage(userDocId, alimentazioneId, {
      text: "File caricato con successo!",
      type: "success",
    });
  } catch (error) {
    console.error("Errore durante il caricamento del file:", error);
    this.setUploadMessage(userDocId, alimentazioneId, {
      text: "Errore durante il caricamento del file. Riprova.",
      type: "error",
    });
    this.clearDropPreview(userDocId, alimentazioneId);
  } finally {
    const nextStates = { ...this.uploadingStates };
    delete nextStates[key];
    this.uploadingStates = nextStates;
    this.setDropZoneState(userDocId, alimentazioneId, false);
  }
},

updateLocalAlimentazione(collection, userDocId, alimentazioneId, fields) {
  if (!Array.isArray(collection)) return;
  const userIndex = collection.findIndex((user) => user.id === userDocId);
  if (userIndex === -1) return;

  const user = collection[userIndex];
  const alimentazioni = Array.isArray(user.alimentazioni) ? [...user.alimentazioni] : [];
  const alimentazioneIndex = alimentazioni.findIndex((alim) => alim.id === alimentazioneId);
  if (alimentazioneIndex === -1) return;

  const updatedAlim = {
    ...alimentazioni[alimentazioneIndex],
    ...fields,
  };

  alimentazioni.splice(alimentazioneIndex, 1, updatedAlim);
  const updatedUser = {
    ...user,
    alimentazioni,
  };

  collection.splice(userIndex, 1, updatedUser);
},

updateLocalUser(collection, userDocId, fields) {
  if (!Array.isArray(collection)) return;
  const userIndex = collection.findIndex((user) => user.id === userDocId);
  if (userIndex === -1) return;

  const updatedUser = {
    ...collection[userIndex],
    ...fields,
  };

  collection.splice(userIndex, 1, updatedUser);
},

async handleUserChange(newDocId) {
    if (!newDocId) return;

    if (this.activeDocId && this.activeDocId !== newDocId) {
      try {
        await this.savePendingChanges(this.activeDocId);
        console.log(`Modifiche salvate per il documento: ${this.activeDocId}`);
      } catch (error) {
        console.error(`Errore durante il salvataggio delle modifiche per ${this.activeDocId}:`, error);
      }
    }

    this.activeDocId = newDocId;
    console.log(`Documento attivo aggiornato a: ${newDocId}`);
    this.lastFocusedUserId = newDocId;
  },



openDatePicker(userId, fieldOrIndex) {
  if (!this.canEdit) return;
  const key = `${userId}-${fieldOrIndex}`;
  this.activeDatePickers[key] = true; // Apre il campo data
},



closeDatePicker(userId, fieldOrIndex) {
  const key = `${userId}-${fieldOrIndex}`;
  delete this.activeDatePickers[key]; // Chiude il campo data
},


isDatePickerOpen(userId, fieldOrIndex) {
  const key = `${userId}-${fieldOrIndex}`;
  return !!this.activeDatePickers[key];
},





formatDateForInput(date) {
  if (!date) return ''; // Se la data è nulla, restituisce una stringa vuota
  if (date.toDate) {
    // Se è un Timestamp di Firestore
    return date.toDate().toISOString().split('T')[0];
  }
  if (date instanceof Date) {
    // Se è un oggetto Date
    return date.toISOString().split('T')[0];
  }
  console.warn('Formato data non riconosciuto in formatDateForInput:', date);
  return '';
},

scheduleLocalFieldRefresh(userId) {
  if (this.localFieldRefreshTimeouts[userId]) return;
  this.localFieldRefreshTimeouts[userId] = setTimeout(() => {
    delete this.localFieldRefreshTimeouts[userId];
    [this.userData, this.filteredUserData, this.savedUserData].forEach((users) => {
      this.applyPendingEditsToCollection(users, userId);
    });
  }, 100);
},

updateField(userId, alimentazioneId, field, value) {
  if (!this.canEdit) return;
  if (field === "dataCreazione") {
    const dateObject = new Date(value); // Converte la stringa in un oggetto Date
    value = Timestamp.fromDate(dateObject); // Converte Date in Timestamp Firestore
  }

  // Inizializza l'oggetto editedFields se non esiste già per l'utente
  if (!this.editedFields[userId]) {
    this.editedFields[userId] = {};
  }

  if (alimentazioneId) {
    if (!this.editedFields[userId][alimentazioneId]) {
      this.editedFields[userId][alimentazioneId] = {};
    }
    this.editedFields[userId][alimentazioneId][field] = value;
  } else {
    this.editedFields[userId][field] = value;
  }

  // Inputs read editedFields immediately; batch only the heavier local list updates.
  this.scheduleLocalFieldRefresh(userId);

  const filterSensitiveFields = new Set([
    "videocall",
    "nutrizionistadiet",
    "noteselect"
  ]);

  if (filterSensitiveFields.has(field)) {
    this.queueFilterRefresh();
  }

  const autoSaveFields = new Set([
    "nutrizionista",
    "videocall",
    "nutrizionistadiet",
    "noteselect",
    "consegnaConfirmed",
    "consegnaConfirmedAt",
    "progCustomizzato",
    "progCustomizzatoAt"
  ]);

  if (autoSaveFields.has(field) && alimentazioneId) {
    this.scheduleAutoSave(userId);
  }

  // Chiude il calendario dopo la selezione solo per il campo data
  if (field === "dataCreazione") {
    this.closeDatePicker(userId, alimentazioneId);
  }
},





updateDataConsegna(userId, value) {
  if (!userId) return;
  if (!this.canEdit) return;

  let timestamp = null;
  if (value) {
    const dateObject = new Date(value);
    if (!Number.isNaN(dateObject.getTime())) {
      timestamp = Timestamp.fromDate(dateObject);
    }
  }

  let currentValue = null;
  const existingUser = this.userData.find((u) => u.id === userId);
  if (existingUser) {
    currentValue = existingUser.dataConsegna || null;
  } else {
    const savedUser = this.savedUserData.find((u) => u.id === userId);
    currentValue = savedUser ? savedUser.dataConsegna || null : null;
  }

  if (this.areTimestampsEqual(currentValue, timestamp)) {
    this.closeDatePicker(userId, "dataConsegna");
    return;
  }

  this.lastFocusedUserId = userId;
  this.shouldPreserveFocus = true;

  const updatePayload = { dataConsegna: timestamp };
  [this.userData, this.filteredUserData, this.savedUserData].forEach((collection) => {
    this.updateLocalUser(collection, userId, updatePayload);
  });

  this.dataConsegnaPending = {
    ...this.dataConsegnaPending,
    [userId]: timestamp,
  };

  if (this.editedFields[userId]) {
    const remaining = { ...this.editedFields[userId] };
    delete remaining.dataConsegna;
    if (Object.keys(remaining).length) {
      this.editedFields[userId] = remaining;
    } else {
      delete this.editedFields[userId];
    }
  }

  this.scheduleDataConsegnaSave(userId);
  this.closeDatePicker(userId, "dataConsegna");
  this.queueFilterRefresh();
  this.scrollUserRowIntoView(userId);
},


updateDataCreazione(userId, alimentazioneId, value) {
  if (!this.canEdit) return;
  const dateObject = new Date(value); // Converte la stringa in un oggetto Date
  const timestamp = Timestamp.fromDate(dateObject); // Converte Date in Timestamp Firestore

  // Aggiorna localmente il campo dataCreazione nell'array alimentazioni
  const user = this.userData.find((u) => u.id === userId);
  if (user && Array.isArray(user.alimentazioni)) {
    const target = user.alimentazioni.find((alim) => alim.id === alimentazioneId);
    if (target) {
      target.dataCreazione = timestamp;
    }
  }

  // Salva la modifica nel buffer delle modifiche locali
  if (!this.editedFields[userId]) {
    this.editedFields[userId] = {};
  }
  if (!this.editedFields[userId][alimentazioneId]) {
    this.editedFields[userId][alimentazioneId] = {};
  }
  this.editedFields[userId][alimentazioneId].dataCreazione = timestamp;

  console.log(`Campo 'dataCreazione' aggiornato per utente ${userId}, alimentazione ${alimentazioneId}:`, timestamp);
  this.closeDatePicker(userId, alimentazioneId);
},



    // Salva eventuali modifiche pendenti per il documento specificato
    async savePendingChanges(docId) {
      if (!docId) return;
      const targetUser =
        this.userData.find((user) => user.id === docId) ||
        this.savedUserData.find((user) => user.id === docId);

      if (!targetUser) {
        console.warn(`savePendingChanges: documento ${docId} non trovato localmente`);
        return;
      }

      await this.persistChangesForUser(targetUser);
    },

async runSyncForUser(targetUser) {
  if (!targetUser) {
    return {
      hadUpdates: false,
      mirrorResult: { changed: false, changedEntries: 0, changedDocs: 0 },
      changed: false,
    };
  }

  return this.enqueueUserSave(targetUser.id, async () => {
    const hadUpdates = await this.persistUserFieldChanges(targetUser, { showSpinner: false });
    const mirrorResult = await this.forceMirrorFlagsCopyForUser(targetUser);
    return {
      hadUpdates,
      mirrorResult,
      changed: !!hadUpdates || !!mirrorResult?.changed,
    };
  });
},

async syncData(docId) {
  if (!this.canEdit) return;
  if (this.bulkSyncRunning) return;
  if (this.syncingUserId) return;

  this.lastFocusedUserId = docId;
  this.shouldPreserveFocus = true;

  const targetUser = this.userData.find((user) => user.id === docId);
  if (!targetUser) {
    console.warn(`syncData: nessun utente trovato con documento ${docId}`);
    return;
  }

  this.syncingUserId = docId;
  await this.waitForFrame();

  try {
    const { hadUpdates, mirrorResult } = await this.runSyncForUser(targetUser);

    if (!hadUpdates && !mirrorResult.changed) {
      console.log(`Nessuna modifica da sincronizzare per documento: ${docId}`);
    } else {
      console.log(
        `Sync completata per ${docId}: edit=${hadUpdates ? "si" : "no"}, mirrorDocs=${mirrorResult.changedDocs}, mirrorEntry=${mirrorResult.changedEntries}`
      );
    }
  } finally {
    this.syncingUserId = null;
    if (this.shouldPreserveFocus && this.lastFocusedUserId) {
      this.scrollUserRowIntoView(this.lastFocusedUserId);
    }
  }
},

async syncAllFilteredUsers() {
  if (!this.canSeeBulkSyncAll) return;
  if (this.bulkSyncRunning) return;
  if (this.syncingUserId) return;
  if (this.missingLastConsegnaLoading) return;

  const userIds = Array.isArray(this.visibleUserData)
    ? [...new Set(this.visibleUserData.map((user) => user?.id).filter(Boolean))]
    : [];
  if (!userIds.length) {
    alert("Nessun utente visibile da sincronizzare.");
    return;
  }

  const confirmMessage =
    `Sincronizzare ${userIds.length} utenti visibili?\n\n` +
    "Verranno allineati i flag Consegnato e Prog. customizzato da percorsi verso Invii.";
  if (typeof window !== "undefined" && !window.confirm(confirmMessage)) {
    return;
  }

  this.bulkSyncRunning = true;
  this.bulkSyncTotal = userIds.length;
  this.bulkSyncDone = 0;
  this.bulkSyncChangedUsers = 0;
  this.bulkSyncErrors = 0;
  this.bulkSyncLastSummary = "";

  try {
    for (const userId of userIds) {
      this.syncingUserId = userId;
      await this.waitForFrame();

      try {
        const targetUser =
          this.userData.find((user) => user.id === userId) ||
          this.savedUserData.find((user) => user.id === userId) ||
          this.filteredUserData.find((user) => user.id === userId);
        const syncResult = await this.runSyncForUser(targetUser);
        if (syncResult.changed) {
          this.bulkSyncChangedUsers += 1;
        }
      } catch (error) {
        this.bulkSyncErrors += 1;
        console.error(`Errore sync massiva utente ${userId}:`, error);
      } finally {
        this.bulkSyncDone += 1;
        this.syncingUserId = null;
      }
    }
  } finally {
    this.bulkSyncRunning = false;
    this.shouldPreserveFocus = false;
    this.lastFocusedUserId = null;

    this.bulkSyncLastSummary =
      `Sync completata: ${this.bulkSyncDone}/${this.bulkSyncTotal}, ` +
      `aggiornati ${this.bulkSyncChangedUsers}, errori ${this.bulkSyncErrors}.`;
    console.log(this.bulkSyncLastSummary);
  }
},

async persistChangesForUser(targetUser, options = {}) {
  if (!targetUser) return false;
  return this.enqueueUserSave(targetUser.id, () => this.persistUserFieldChanges(targetUser, options));
},

async persistUserFieldChanges(targetUser, options = {}) {
  const { showSpinner = false } = options;
  if (!targetUser) return false;
  const docId = targetUser.id;
  const userUid = targetUser.uid || targetUser.id;
  // Capture only this save's edits, so a later edit is never cleared on completion.
  const pending = this.editedFields[docId];
  if (!pending || !Object.keys(pending).length) return false;
  const pendingChanges = Object.fromEntries(Object.entries(pending).map(([key, value]) => [
    key, value && Object.getPrototypeOf(value) === Object.prototype ? { ...value } : value
  ]));
  if (showSpinner) this.syncingUserId = docId;
  const db = getFirestore();
  const inviiRef = doc(db, "inviidigiornata", docId);
  const alimentazioniRef = doc(db, "alimentazioni", userUid);
  const singleFields = new Set(["phone", "dataConsegna", "rowColor", "notes", "noteAlimentazione", "noteAllenamento"]);
  try {
    const result = await runTransaction(db, async (transaction) => {
      const [inviiSnap, canonicalSnap] = await Promise.all([
        transaction.get(inviiRef), transaction.get(alimentazioniRef),
      ]);
      if (!inviiSnap.exists()) throw new Error("Invio non più disponibile. Ricarica la pagina.");
      const inviiEntries = Array.isArray(inviiSnap.data().alimentazioni) ? inviiSnap.data().alimentazioni : [];
      const canonicalEntries = canonicalSnap.exists() && Array.isArray(canonicalSnap.data().alimentazioni)
        ? canonicalSnap.data().alimentazioni : [];
      const canonicalMap = new Map(canonicalEntries.map((entry) => [entry.id, entry]));
      const inviiMap = new Map(inviiEntries.map((entry) => [entry.id, entry]));
      const mergedMap = new Map(canonicalEntries.map((entry) => [entry.id, { ...entry }]));
      inviiEntries.forEach((entry) => {
        if (entry?.id) mergedMap.set(entry.id, { ...mergedMap.get(entry.id), ...entry });
      });
      const normalizedSingleUpdates = {};
      let changed = false;
      Object.entries(pendingChanges).forEach(([key, value]) => {
        if (singleFields.has(key)) {
          normalizedSingleUpdates[key] = value === "" ? null : value;
          return;
        }
        if (!value || typeof value !== "object") return;
        const entry = mergedMap.get(key);
        if (!entry) throw new Error("Alimentazione non più disponibile. Ricarica la pagina.");
        Object.entries(value).forEach(([field, fieldValue]) => {
          if (INTEGRATION_FIELDS.includes(field)) return;
          entry[field] = fieldValue === "" ? null : fieldValue;
          changed = true;
        });
      });
      const merged = [...mergedMap.values()].sort((a, b) => this.compareProgramDates(a, b));
      // Each copy keeps its own integration history. Generic saves cannot overwrite it.
      const nextInvii = merged.map((entry) => preserveIntegrationFields(entry, inviiMap.get(entry.id) || canonicalMap.get(entry.id)));
      const nextCanonical = merged.map((entry) => preserveIntegrationFields(entry, canonicalMap.get(entry.id) || inviiMap.get(entry.id)));
      const updatePayload = {
        ...normalizedSingleUpdates,
        ...(changed ? { alimentazioni: nextInvii, ...buildLatestProgramMirror(nextInvii) } : {}),
      };
      if (!Object.keys(updatePayload).length) return null;
      transaction.update(inviiRef, updatePayload);
      transaction.set(alimentazioniRef, {
        ...normalizedSingleUpdates,
        ...(changed ? { alimentazioni: nextCanonical } : {}),
        userId: userUid,
      }, { merge: true });
      return { ...normalizedSingleUpdates, ...(changed ? { alimentazioni: nextInvii } : {}) };
    });
    if (!result) return false;
    this.applyCommittedInviiChanges(docId, result, pendingChanges);
    return true;
  } catch (error) {
    console.error("Errore durante la sincronizzazione dei dati:", error);
    alert("Salvataggio non riuscito. Le modifiche restano in attesa: riprova.");
    return false;
  } finally {
    if (showSpinner) this.syncingUserId = null;
  }
},





    // Converte un Timestamp in una stringa leggibile
    formatTimestamp(timestamp) {
      if (!timestamp) return "";
      const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
      return date.toLocaleDateString("it-IT", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      });
    },
  },
};
</script>









<style scoped>

.filter-module-fixed {
  position: fixed;
  bottom: 90px; /* Distanza dal bordo superiore */
  right: 40px; /* Distanza dal bordo destro */
  width: 920px; /* Larghezza del modulo */
  max-height: 90vh; /* Altezza massima per evitare overflow */
  overflow-y: auto; /* Scroll verticale se necessario */
  background-color: #363636 !important; /* Sfondo bianco */
  border-radius: 30px !important;
  padding: 50px !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  transition: transform 0.3s ease, opacity 0.3s ease;
  transform: translateX(100%); /* Fuori dallo schermo inizialmente */
  opacity: 0;

}

.filter-module-fixed.show {
  transform: translateX(0); /* Mostra il modulo */
  opacity: 1;
}


.filter-toggle-button {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 100px;
  height: 100px;
  font-size: 15px;
  font-weight: bold;
  border: none;
  border-radius: 50%; /* Rende il bottone perfettamente tondo */
  cursor: pointer;
  background-color: #007bff;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s ease, transform 0.2s ease;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.filter-toggle-button:hover {
  background-color: #0056b3;
  transform: scale(1.1); /* Effetto hover leggero */
}



.alimentazione-cell {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.integrazione-cell {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.integrazione-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #474747;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  box-shadow: 0 4px 10px rgba(31, 41, 55, 0.2);
  height: 50px;
}

.integrazione-button:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.integrazione-button:hover {
  background: #a3a3a3;
  transform: translateY(1px);
}

.integrazione-button__icon {
  font-size: 18px;
}

.integrazione-summary {
  font-size: 12px;
  color: #374151;
  line-height: 1.4;
}

.btn-spinner {
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.5);
  border-top-color: #ffffff;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
  animation: spin 0.8s linear infinite;
  vertical-align: middle;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.alimentazione-row {
  display: flex;              /* Allinea gli elementi orizzontalmente */
  align-items: center;        /* Centra verticalmente data e pulsante */
  gap: 0px;                   /* Spazio tra la data e il pulsante */
  margin-bottom: 0px;         /* Spazio tra le righe */
}

.date-display {
  font-weight: bold;
  color: red;
  cursor: pointer;
}

.delete-button {
  background: none;           /* Rimuove lo sfondo */
  border: none;               /* Rimuove il bordo */
  padding: 0;
  cursor: pointer;            /* Cambia il cursore in puntatore */
}

.delete-button .material-icons {
  color: #333;                /* Colore del cestino */
}

.delete-button:hover .material-icons {
  color: #5b0000;             /* Colore rosso più scuro al passaggio del mouse */
}

.delete-button:hover .material-icons {
  color: #5b0000;             /* Colore rosso più scuro al passaggio del mouse */
}



.email-link {
  color: #007bff;       /* Colore blu per il link */
  text-decoration: none; /* Rimuove la sottolineatura */
  font-weight: bold;     /* Grassetto */
}

.email-link:hover {
  text-decoration: underline; /* Sottolineatura al passaggio del mouse */
}


/* Stile opzionale per il messaggio */
.read-only-message {
  color: #ff9800;     /* Colore arancione */
  font-weight: bold;  /* Testo in grassetto */
  margin-bottom: 10px;
}


.no-border {
  border: none;      /* Rimuove la linea nera */
  padding: 0;        /* Rimuove il padding */
  margin: 0;         /* Opzionale: rimuove eventuali margini */
}



.color-select {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
  background-color: #fff;
}

.color-select:focus {
  border-color: #4caf50;
}


/* Miglioramenti Generali per la Tabella */
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed; /* Larghezze fisse */
}

th,
td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

th {
  background-color: #f1f1f1;
  font-weight: 600;
  text-align: left;
}

/* Righe alternate per maggiore leggibilità */
tbody tr:nth-child(odd) {
  background-color: #ffffff; /* Bianco */
}

tbody tr:nth-child(even) {
  background-color: #f9f9f9; /* Grigio chiaro */
}

tbody tr:hover {
  background-color: #f1f1f1; /* Colore di hover */
}

.program-row.user-group-start {
  border-top: 4px solid #c5cae9;
  box-shadow: inset 0 1px 0 #e0e0e0;
}

/* Colori personalizzati con priorità */
tbody tr.bg-red {
  background-color: rgba(255, 0, 0, 0.1) !important;
}

tbody tr.bg-green {
  background-color: rgba(0, 255, 0, 0.1) !important;
}

tbody tr.bg-blue {
  background-color: rgba(0, 0, 255, 0.1) !important;
}

tbody tr.bg-yellow {
  background-color: rgba(255, 255, 0, 0.1) !important;
}

tbody tr.bg-orange {
  background-color: rgba(255, 165, 0, 0.1) !important;
}

tbody tr.bg-pink {
  background-color: rgba(255, 192, 203, 0.1) !important;
}

tbody tr.bg-protocollo {
  background-color: rgba(255, 88, 0, 0.4) !important;
}

.tickets {
  margin-bottom: 120px;
}

.dataset-summary {
  margin: 16px 0;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  font-size: 14px;
  color: #333;
}

.dataset-summary__status {
  font-style: italic;
  color: #777;
}

.dataset-summary__sync-all {
  width: auto;
  min-width: 190px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 13px;
  box-shadow: none;
}

.dataset-summary__missing-filter {
  width: auto;
  min-width: 230px;
  padding: 8px 12px;
  border-radius: 8px;
  font-size: 13px;
  box-shadow: none;
  background-color: #0f766e;
}

.dataset-summary__missing-filter:hover:not(:disabled) {
  background-color: #0d5f59;
  box-shadow: 0 8px 18px rgba(15, 118, 110, 0.24);
}

.dataset-summary__missing-filter.is-active:not(.syncing) {
  background-color: #475569;
  box-shadow: 0 6px 14px rgba(71, 85, 105, 0.18);
}


.color-select {
  width: 100%;
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #f9f9f9;
  font-size: 14px;
}

.color-select option {
  font-weight: bold;
}

.col-color {
  width: 120px;
}

.sync-block {
  display: flex;
  width: 100%;
}

.sync-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 12px 14px;
  background-color: #0d6efd;
  color: #ffffff;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  box-shadow: 0 6px 14px rgba(13, 110, 253, 0.2);
  transition: background-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease, opacity 0.2s ease;
}

.sync-button:hover:not(:disabled) {
  background-color: #0b5ed7;
  box-shadow: 0 8px 18px rgba(13, 110, 253, 0.24);
  transform: translateY(-1px);
}

.sync-button:disabled {
  cursor: not-allowed;
  opacity: 0.75;
  box-shadow: none;
}

.sync-button__icon {
  font-size: 20px;
}

.sync-button.syncing {
  background-color: #f59e0b;
  box-shadow: 0 6px 14px rgba(245, 158, 11, 0.18);
}

.sync-button.syncing .sync-button__icon {
  animation: sync-rotate 1s linear infinite;
}

@keyframes sync-rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.add-button {
  margin-top: 7px;
  padding: 7px 7px;
  background-color: #6b6b6b;
  color: white;
  border: none;
  border-radius: 7px;
  cursor: pointer;
  font-size: 14px;
}

.add-button:hover {
  background-color: #0056b3;
}



.date-display {
  cursor: pointer;
  padding: 4px 8px;
  border: 1px solid transparent;
  background: none;
  color: #333;
  font-size: 14px;
}
.date-display:hover {
  border: 1px solid #ccc;
  background: #f9f9f9;
  border-radius: 4px;
}
.date-picker {
  padding: 4px 8px;
  border: 1px solid #ccc;
  font-size: 14px;
  border-radius: 4px;
  width: auto;
}


.col-studio {
  width: 120px;
}

.col-note-interna {
  width: 420px;
}

.col-documenti {
  width: 220px;
  padding-right: 28px;
}

.file-actions {
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: flex-start;
  width: 100%;
}

.upload-button {
  padding: 6px 10px;
  background-color: #6b6b6b;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 13px;
  transition: background-color 0.2s ease;
}

.upload-button:hover {
  background-color: #5a5a5a;
}

.upload-button:disabled {
  background-color: #a0a0a0;
  cursor: not-allowed;
}

.file-info {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.file-link {
  color: #007bff;
  text-decoration: none;
  font-weight: 600;
}

.file-link:hover {
  text-decoration: underline;
}

.profile-button--link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
}
.profile-button--unavailable { opacity: .4; cursor: not-allowed; }

.file-date {
  font-size: 12px;
  color: #555;
}

.file-dropzone {
  width: 100%;
  padding: 10px;
  border: 2px dashed #b5b5b5;
  border-radius: 8px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 13px;
  color: #555;
  background-color: #fafafa;
  transition: border-color 0.2s ease, background-color 0.2s ease, color 0.2s ease;
  cursor: pointer;
}

.file-dropzone.has-preview {
  border-color: #0d6efd;
  background-color: #f0f6ff;
  color: #0b5ed7;
}

.file-dropzone.is-dragover {
  border-color: #4a90e2;
  background-color: #e8f0fe;
  color: #1a73e8;
}

.file-dropzone.is-uploading {
  border-color: #007bff;
  background: linear-gradient(135deg, rgba(0, 123, 255, 0.08), rgba(0, 123, 255, 0));
  color: #0056b3;
}

.file-dropzone.is-disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.file-dropzone.is-disabled .file-dropzone__prompt {
  color: #6b7280;
}

.file-dropzone:focus-visible {
  outline: none;
  border-color: #1a73e8;
  box-shadow: 0 0 0 3px rgba(26, 115, 232, 0.2);
}

.file-dropzone__spinner {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(0, 86, 179, 0.2);
  border-top-color: #0056b3;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.file-dropzone__icon {
  font-size: 18px;
  color: currentColor;
}

.file-dropzone__prompt {
  max-width: 160px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.file-status {
  font-size: 12px;
  margin-top: 4px;
  padding: 4px 6px;
  border-radius: 4px;
  background-color: #f1f1f1;
  color: #333;
}

.file-status--loading {
  background-color: #e8f0fe;
  color: #1a73e8;
}

.file-status--success {
  background-color: #e6f4ea;
  color: #1e8e3e;
}

.file-status--error {
  background-color: #fdecea;
  color: #d93025;
}

.col-note-interna .note-textarea {
  width: 100%; /* Adatta la larghezza al contenitore */
  height: auto; /* Annulla altezza fissa globale */
  max-height: 500px; /* Limita l'altezza massima */
  resize: vertical !important; /* Consente il ridimensionamento verticale e orizzontale */
  overflow: auto !important; /* Mostra la barra di scorrimento se necessario */
  box-sizing: border-box; /* Considera il padding nella larghezza */
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 14px;
  font-size: 14px;
  line-height: 1.5; /* Migliora la leggibilità del testo */
  margin-top: 0px !important;
}






.col-note-nutrizionista {
  width: 200px;
  border-left: 13px solid rgb(44, 177, 0); /* Riga verde tra Note e Testo */
  padding-left: 30px;
}

.col-nutrizionista-diet {
  width: 200px;
  padding-right: 30px;

}


.col-azione {
  width: 50px;
}

.col-data {
  width: 150px;
}

.col-nome,
.col-cognome {
  width: 120px;
  font-weight: 800;

}

.col-alimentazioni {
  width: 200px;
}

.col-allenamento {
  width: 250px;
}

.col-kcal {
  width: 100px;
}

.col-strategia {
  width: 200px;
}

.col-integrazione {
  width: 200px;
}

.col-videocall {
  width: 200px;

}

.col-freq {
  width: 120px;
  padding-right: 30px;

}

.col-email {
  width: 300px;
font-weight: 800;
}
.col-phone {
  width: 200px;
}

.col-statoutente {
  width: 100px;
  border-left: 13px solid rgb(0, 126, 210); /* Riga verde tra Note e Testo */
  padding-left: 30px;

}
.col-notes {
  width: 300px;

}

.col-note-select {
  width: 150px;
  border-left: 13px solid rgb(210, 157, 0); /* Riga verde tra Note e Testo */
  padding-left: 30px;

}

.col-note-alimentazione,
.col-note-allenamento {
  width: 300px;
}

.col-sincr {
  width: 150px;
  padding-left: 12px;
}

.col-consegna {
  width: 230px;
  padding-left: 12px;
}

.consegna-box {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px 12px;
  border-radius: 12px;
  background: #f8fafc;
  border: 1px solid #e6ebf2;
}

.consegna-header {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.consegna-title {
  font-size: 13px;
  font-weight: 700;
  color: #1d1d1d;
}

.consegna-step-tag {
  display: inline-flex;
  align-items: center;
  width: fit-content;
  padding: 2px 8px;
  border-radius: 999px;
  background-color: #eef2f6;
  color: #243447;
  font-size: 12px;
  font-weight: 600;
}

.consegna-steps {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.consegna-step-item {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 6px 10px;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid transparent;
  transition: background-color 0.2s ease, border-color 0.2s ease;
}

.consegna-step-item input {
  width: 14px;
  height: 14px;
}

.consegna-step-item--custom {
  background-color: #f1f6ff;
  color: #1c3d5f;
  border-color: #dbe7ff;
}

.consegna-step-item--delivery {
  background-color: #f1fbf4;
  color: #1f4a32;
  border-color: #d9f3e1;
}

.consegna-step-item.is-done {
  background-color: #e0f2ff;
  border-color: #b7d8ff;
}

.consegna-step-item--delivery.is-done {
  background-color: #ddf7e6;
  border-color: #b7e6c8;
}

.consegna-step-item.is-disabled {
  opacity: 0.6;
}

.consegna-program-select,
.consegna-status-select {
  font-size: 13px;
}

.consegna-status-select:disabled {
  background-color: #f5f5f5;
  color: #6c6c6c;
}

.consegna-hint {
  font-size: 11px;
  color: #6c6c6c;
}

.consegna-hint--error {
  color: #c53030;
}


.text-input {
  width: 100%;
  box-sizing: border-box;
}

.program-row td {
  vertical-align: top;
}

.program-row--latest td {
  background-color: #d9dce2;
}

tbody tr.program-row--latest:hover td {
  background-color: #e5eaf1;
}

.program-row--latest.bg-red td {
  background-color: rgba(255, 0, 0, 0.2) !important;
}

tbody tr.program-row--latest.bg-red:hover td {
  background-color: rgba(255, 0, 0, 0.24) !important;
}

.program-row--latest.bg-green td {
  background-color: rgba(0, 255, 0, 0.2) !important;
}

tbody tr.program-row--latest.bg-green:hover td {
  background-color: rgba(0, 255, 0, 0.24) !important;
}

.program-row--latest.bg-blue td {
  background-color: rgba(0, 0, 255, 0.2) !important;
}

tbody tr.program-row--latest.bg-blue:hover td {
  background-color: rgba(0, 0, 255, 0.24) !important;
}

.program-row--latest.bg-yellow td {
  background-color: rgba(255, 255, 0, 0.2) !important;
}

tbody tr.program-row--latest.bg-yellow:hover td {
  background-color: rgba(255, 255, 0, 0.24) !important;
}

.program-row--latest.bg-orange td {
  background-color: rgba(255, 165, 0, 0.2) !important;
}

tbody tr.program-row--latest.bg-orange:hover td {
  background-color: rgba(255, 165, 0, 0.24) !important;
}

.program-row--latest.bg-pink td {
  background-color: rgba(255, 192, 203, 0.2) !important;
}

tbody tr.program-row--latest.bg-pink:hover td {
  background-color: rgba(255, 192, 203, 0.24) !important;
}

.program-row--latest.bg-protocollo td {
  background-color: rgba(255, 88, 0, 0.52) !important;
}

tbody tr.program-row--latest.bg-protocollo:hover td {
  background-color: rgba(255, 88, 0, 0.58) !important;
}

.program-row--latest .date-display {
  font-weight: 700;
}

.empty-cell {
  color: #6c6c6c;
  font-style: italic;
}


</style>
